// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:15:49.331Z
// Property: Rivers Edge at Carolina Stadium (ID: 6737460151191766)
// Collections: 22 amenities, 20 floorplans (live), 45 photos, 98 POIs, 4 reviews, 1 virtual tours, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151191766",
  "property_external_id": "5106325",
  "property_zillow_url": "https://www.zillow.com/homedetails/1-Catawba-Cir-Columbia-SC-29201/10973712_zpid/",
  "property_apartments_url": "https://www.apartments.com/rivers-edge-at-carolina-stadium-columbia-sc/rh83eg1/",
  "property_google_business_url": "https://www.google.com/maps/place/Rivers+Edge+at+Carolina+Stadium/data=!4m2!3m1!1s0x0:0xcd335542836f58f?sa=X&ved=2ahUKEwjJtYLNvbySAxXZBNsEHfZLMOoQ_BJ6BAgOEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321118531",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "rivers-edge-at-carolina-stadium",
  "property_name": "Rivers Edge at Carolina Stadium",
  "property_website_url": "https://www.riversedgecs.com/",
  "property_domain": "https://www.riversedgecs.com/",
  "property_address": "1 Catawba Cir",
  "property_full_address": "1 Catawba Cir, Columbia, SC 29201",
  "property_address_1": "1 Catawba Cir",
  "property_address_2": null,
  "property_address_city": "Columbia",
  "property_address_state": "SC",
  "property_address_zip_full": "29201-5266",
  "property_address_zip": "29201",
  "property_address_country": "US",
  "property_address_county": "Richland County",
  "property_neighborhood_address": "Olympia-Granby",
  "property_address_latitude": "33.9811663",
  "property_address_longitude": "-81.0429431",
  "property_email": "riversedge@rreafresidential.com",
  "property_phone": "(803) 779-5888",
  "property_call_tracking_phone": "803-784-8789",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Rivers Edge at Carolina Stadium in scenic Columbia, SC, your ideal home awaits. Choose from spacious one, two, or three-bedroom apartments featuring modern amenities like stainless steel appliances, air conditioning, and private patios. Embrace a lifestyle of comfort and style—browse our availability or schedule a tour today!",
  "property_long_description": "Welcome to Rivers Edge at Carolina Stadium, your ideal apartment community nestled in the heart of Columbia, SC. With thoughtfully designed floor plans, including spacious one, two, and three-bedroom apartments, you’ll find the perfect space to fit your lifestyle. Every apartment features modern amenities such as air conditioning, stainless steel appliances, a convenient washer and dryer, and a well-equipped kitchen complete with a dishwasher and microwave. Select units also offer a private balcony or patio, perfect for enjoying your morning coffee or unwinding after a long day.\n\nOur community amenities enhance your living experience, offering a welcoming lounge where residents can relax and socialize. Plus, with walk-up access, you’ll enjoy easy entry to your new home. Whether you’re seeking a cozy one-bedroom sanctuary or need more space in our roomy three-bedroom options, Rivers Edge provides the perfect setting for your next chapter.\n\nLocated conveniently near local attractions, dining, and entertainment, Rivers Edge at Carolina Stadium combines comfort and convenience. Don't miss out on the opportunity to call this vibrant community home. \n\nFind your new home today—browse our availability or schedule a tour to visit our community! Embrace the lifestyle you deserve at Rivers Edge.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019dec99-7909-7480-a0f3-7b45381eb0bd.webp",
  "property_featured_image_media": {
    "alt_text": "Gym with treadmills, stair climbers, weight machines, and a view of the outdoor pool.",
    "public_id": "019dec99-7909-7480-a0f3-7b45381eb0bd",
    "storage_key": "property/6737460151191766/019dec99-7909-7480-a0f3-7b45381eb0bd.webp",
    "width": 2048,
    "height": 1368
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "486",
  "property_year_built": "1996",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.4156378600823",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": "3",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": null,
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": "TBD",
  "property_online_leasing_url": "https://www.on-site.com/web/online_app3/510261/step/floorplan",
  "property_resident_portal_url": "https://riversedgeatcarolinastadium.loftliving.com/login",
  "property_apply_now_url": "https://8971499.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-a0bc-7425-a87f-72ebe43b9f71.webp",
  "property_primary_logo_media": {
    "alt_text": "Rivers Edge at Carolina Stadium logo",
    "public_id": "019e1e2c-a0bc-7425-a87f-72ebe43b9f71",
    "storage_key": "property/6737460151191766/019e1e2c-a0bc-7425-a87f-72ebe43b9f71.webp",
    "width": 1250,
    "height": 1004
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-9ffa-72ce-9d89-97b538f4c148.webp",
  "property_secondary_logo_media": {
    "alt_text": "Rivers Edge at Carolina Stadium logo with a teal river graphic.",
    "public_id": "019e1e2c-9ffa-72ce-9d89-97b538f4c148",
    "storage_key": "property/6737460151191766/019e1e2c-9ffa-72ce-9d89-97b538f4c148.webp",
    "width": 1250,
    "height": 1004
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e8498-f71c-71ba-bf93-e3543a0aca92.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019e8498-f71c-71ba-bf93-e3543a0aca92",
    "storage_key": "property/6737460151191766/019e8498-f71c-71ba-bf93-e3543a0aca92.webp",
    "width": 1250,
    "height": 1004
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e8498-ebac-759b-849f-05a4c656117e.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e8498-ebac-759b-849f-05a4c656117e",
    "storage_key": "property/6737460151191766/019e8498-ebac-759b-849f-05a4c656117e.webp",
    "width": 1250,
    "height": 1004
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#0c928e",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "564 - 1185",
  "property_sqft_min": "564",
  "property_sqft_max": "1185",
  "property_price_range": "669 - 1510",
  "property_price_min": "669",
  "property_price_max": "1510",
  "property_available_units": 32,
  "property_facebook_url": "https://www.facebook.com/people/Rivers-Edge-at-Carolina-Stadium/61560014242021/",
  "property_instagram_url": "https://www.instagram.com/riversedgecs/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJv3BDTT27-IgRj_U2KFQ10ww",
  "property_youtube_url": "https://www.youtube.com/watch?v=vjV0dZmdM0c",
  "property_yelp_url": "https://www.yelp.com/biz/rivers-edge-at-carolina-stadium-by-intermark-management-columbia",
  "property_tiktok_url": "https://www.tiktok.com/@riversedgecs",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Rivers Edge at Carolina Stadium",
  "property_home_romance_title": "Embrace a Love for Life in Your New Apartment Community",
  "property_home_amenities_blurb": "<p>Choose from 13 spacious and modern 1, 2, and 3-bedroom student apartments, all thoughtfully designed with features like in-unit washer and dryer, private balconies or patios, and valet trash service. Our USC student apartments are also steps away from Columbia’s best restaurants, nightlife, and shopping—perfect for balancing school and social life.</p>",
  "property_home_floorplans_blurb": "<p>Ideally located in Columbia, SC near the University of Southern Carolina campus, the neighborhood surrounding Rivers Edge at Carolina Stadium has so much to offer. Entertainment, restaurants, schools, & services combine to create a conveniently placed home and the perfect student living experience. Check out the neighborhood!</p>",
  "property_home_gallery_blurb": "At Rivers Edge at Carolina Stadium, life unfolds with a perfect blend of comfort and convenience in stylish one, two, and three-bedroom apartments. Enjoy exceptional amenities like a resort-style pool, fitness studio, and a vibrant clubhouse, all just 0.7 miles from campus. Picture yourself living here, where every day feels like a retreat!",
  "property_home_neighborhood_blurb": "Discover vibrant living at Rivers Edge at Carolina Stadium in Columbia, SC! Choose from our spacious one, two, and three-bedroom floor plans to fit your lifestyle. See what's around our community and explore local favorites and nearby points of interest for an enriching experience right at your doorstep!",
  "property_home_reviews_blurb": "At Rivers Edge at Carolina Stadium in Columbia, SC, residents rave about their pristine apartments and well-kept community. One happy tenant shared, \"Everything was in pristine condition... sufficient enough for all of the folks that live here.\" Dive into our community and see why living here feels like home!",
  "property_neighborhood_blurb": "<p>Ideally located in Columbia, SC near the University of Southern Carolina campus, the neighborhood surrounding Rivers Edge at Carolina Stadium has so much to offer. Entertainment, restaurants, schools, & services combine to create a conveniently placed home and the perfect student living experience. Check out the neighborhood!</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Lavish amenities at Rivers Edge at Carolina Stadium in Columbia, SC make student <a href=\"/floor-plans/\">apartment</a> living a breeze. After studying in a private or shared area, breathe in the fresh air on your exquisite balcony or patio, or visit the clubhouse, half-sized basketball court, or pet park to recharge.</p>",
  "property_applynow_blurb": "At Rivers Edge at Carolina Stadium in vibrant Columbia, SC, home awaits you among thoughtfully designed floor plans—one, two, or three bedrooms tailored to your lifestyle. Enjoy modern amenities like stainless steel appliances, private balconies, and a welcoming lounge. Embrace comfort and convenience—lease your new home online today!",
  "property_contactus_blurb": "Discover your perfect home at Rivers Edge at Carolina Stadium in Columbia, SC! Our community features diverse floor plans, including one, two, and three-bedroom apartments to suit your needs. Have questions? Contact our leasing team today to explore your options and schedule a tour. Your ideal space awaits!",
  "property_faqs_blurb": "Discover your ideal home at Rivers Edge at Carolina Stadium in Columbia, SC! Our diverse floor plans include one, two, and three-bedroom options tailored to your lifestyle. Have questions? Browse our FAQs page for answers about our community and experience the comfort and convenience we offer!",
  "property_floorplans_blurb": "<p>Carefree apartment living is what you find when you see Rivers Edge at Carolina Stadium’s floor plans with one, two, and three student bedroom apartments in Columbia, SC. You will be pleased with how easy it is to find your favorite available home with a <a href=\"/amenities/\">balcony or patio, large closets, and stainless steel appliances.</a></p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities of our luxury student housing apartments in Columbia, SC quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/amenities/\">community</a> and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "At Rivers Edge at Carolina Stadium in Columbia, SC, find your perfect fit with spacious one, two, and three-bedroom floor plans. Enjoy modern amenities like stainless steel appliances, cozy balconies, and a relaxing lounge. Check out our interactive community map to easily search for your new home and see pricing!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "Discover your perfect home at Rivers Edge at Carolina Stadium in Columbia, SC! Choose from spacious one, two, or three-bedroom floor plans designed for comfort and convenience. Great friends make great neighbors—refer a friend to our community today and enjoy the inviting atmosphere together! Explore our floor plans now!",
  "property_residentaccess_blurb": "Welcome to Rivers Edge at Carolina Stadium in Columbia, SC! Explore our diverse floor plans, including one, two, and three-bedroom apartments designed for your comfort. Access your resident portal to pay rent, schedule maintenance, and more! Enjoy a seamless living experience at Rivers Edge. Log in today!",
  "property_reviews_blurb": "At Rivers Edge at Carolina Stadium, our residents love calling this pristine community home. One resident shares, “The apartment complex is well kept, neat and sufficient for all of the folks that live here.” Ready to join a vibrant community? See what our residents have to say about living at our community!",
  "property_created_at": "1752257093382",
  "property_scheduletour_blurb": "Discover your perfect home at Rivers Edge at Carolina Stadium in Columbia, SC! Choose from spacious one, two, and three-bedroom floor plans designed for comfort and style. Schedule a tour today and see what our residents have to say about living in this vibrant community! View all floor plans now!",
  "property_thankyou_blurb": "Thank you for your interest in Rivers Edge at Carolina Stadium! Discover our diverse floor plans, including one, two, and three-bedroom apartments, perfect for every lifestyle in beautiful Columbia, SC. A team member will reach out soon to assist you with your next steps towards your new home!",
  "property_virtualtours_blurb": "<p>At Rivers Edge at Carolina Stadium, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360-degree views of your new student apartment in Columbia, SC & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. Rivers Edge at Carolina Stadium",
  "property_seo_title_home": "Rivers Edge at Carolina Stadium | Apartments in Columbia, SC",
  "property_seo_description_home": "Experience Rivers Edge at Carolina Stadium in Columbia, SC—where modern living meets comfort. Choose from stylish one to three-bedroom homes with premium amenities.",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Columbia, SC",
  "property_seo_description_floorplans": "Discover your ideal living space at Rivers Edge at Carolina Stadium in Columbia, SC! Explore our thoughtfully designed one, two, and three-bedroom floor plans that cater to your lifestyle needs. Don't miss out—browse our available apartment homes today and find the perfect floor plan for you!",
  "property_seo_title_amenities": "Amenities | Columbia, SC Apartments for Rent",
  "property_seo_description_amenities": "Experience riverside living at Rivers Edge at Carolina Stadium in Columbia, SC. Unwind in stylish spaces with top-notch amenities—your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Columbia, SC",
  "property_seo_description_gallery": "Capture the charm of riverside living at Rivers Edge at Carolina Stadium. From stylish floor plans to inviting amenities, imagine your life in stunning Columbia, SC!",
  "property_seo_title_virtualtours": "Virtual Tours | Rivers Edge at Carolina Stadium Apartments",
  "property_seo_description_virtualtours": "Discover your ideal home at Rivers Edge at Carolina Stadium in Columbia, SC! Explore our spacious one, two, and three-bedroom floor plans through an immersive virtual tour. Experience modern living with resort-style amenities and a vibrant community atmosphere. Don't miss out—take a virtual tour of our apartments for rent today!",
  "property_seo_title_interactivemap": "Interactive Map | Rivers Edge at Carolina Stadium Apartments",
  "property_seo_description_interactivemap": "Find your perfect haven at Rivers Edge at Carolina Stadium in Columbia, SC. Use our interactive map to browse floor plans and secure your dream apartment today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Columbia, SC",
  "property_seo_description_neighborhood": "Discover the vibrant surroundings of Rivers Edge at Carolina Stadium in Columbia, SC! Explore our welcoming neighborhood featuring nearby favorites and local points of interest. Whether you’re looking for a cozy one-bedroom, a spacious two-bedroom, or a versatile three-bedroom apartment, there's something for everyone. See what's around our community today!",
  "property_seo_title_contact": "Contact Us | Rivers Edge at Carolina Stadium",
  "property_seo_description_contact": "Discover your perfect home at Rivers Edge at Carolina Stadium in Columbia, SC! Explore our diverse floor plans, including spacious one, two, and three-bedroom apartments, designed for your comfort and lifestyle. Have questions? Contact our leasing team today and let us help you find your ideal living space!",
  "property_seo_title_faqs": "FAQs | Apartments in Columbia, SC",
  "property_seo_description_faqs": "Uncover the answers you need at Rivers Edge at Carolina Stadium! From one to three-bedroom layouts to top-notch amenities, your ideal home awaits in Columbia, SC.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Columbia, SC",
  "property_seo_description_reviews": "Join the Rivers Edge at Carolina Stadium family in Columbia, SC! Check out honest reviews from our residents about spacious floor plans, amenities, and community vibe.",
  "property_seo_title_applynow": "Apply Now | Apartments in Columbia, SC",
  "property_seo_description_applynow": "Find your sanctuary at Rivers Edge at Carolina Stadium! Choose from stylish one to three-bedroom homes with top-notch amenities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Rivers Edge at Carolina Stadium",
  "property_seo_description_residentaccess": "\"Welcome to the Residents' Portal at Rivers Edge at Carolina Stadium in Columbia, SC! Log in to easily pay rent, schedule maintenance, and manage your living experience. Simplify your day-to-day tasks with just a few clicks!\"",
  "property_seo_title_referafriend": "Refer A Friend | Rivers Edge at Carolina Stadium",
  "property_seo_description_referafriend": "\"Spread the word about Rivers Edge at Carolina Stadium in Columbia, SC! Refer a friend today and enjoy exclusive rewards. Great friends make great neighbors—join our vibrant community now!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Rivers Edge at Carolina Stadium",
  "property_seo_description_scheduletour": "\"Discover your future home at Rivers Edge at Carolina Stadium in Columbia, SC! Explore our stunning apartments and vibrant community. Schedule a tour today to experience the lifestyle you deserve!\"",
  "property_seo_title_privacy": "Privacy Policy | Rivers Edge at Carolina Stadium",
  "property_seo_description_privacy": "Discover peace of mind at Rivers Edge at Carolina Stadium in Columbia, SC. Our privacy policy outlines how we protect your personal information while you enjoy our community. Your privacy matters to us! View our privacy policy today.",
  "property_seo_title_accessibility": "Website Accessibility | Rivers Edge at Carolina Stadium",
  "property_seo_description_accessibility": "\"Discover Rivers Edge at Carolina Stadium in Columbia, SC, where we prioritize digital inclusion for all. Our Accessibility Statement emphasizes our commitment to providing equal access to information and services for everyone. Join us in creating an inclusive community—learn more today!\"",
  "property_seo_title_sitemap": "Sitemap | Rivers Edge at Carolina Stadium",
  "property_seo_description_sitemap": "\"Explore Rivers Edge at Carolina Stadium in Columbia, SC! Discover our comprehensive sitemap to easily navigate our vibrant apartment community, amenities, and local attractions. View our website sitemap now for a seamless experience!\"",
  "property_seo_title_thankyou": "Thank You | Rivers Edge at Carolina Stadium",
  "property_seo_description_thankyou": "\"Thank you for reaching out to Rivers Edge at Carolina Stadium! Your inquiry is important to us, and a member of our dedicated team will be in touch shortly. Explore vibrant Columbia, SC living with top-notch amenities and a supportive community. Stay tuned for more information!\"",
  "property_seo_title_pets": "Pet Policy | Apartments in Columbia, SC",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293615088",
  "amenities": [
    {
      "id": "ec_8935fa0b81b4be34ee545a21",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "generator",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e6cda9b3317c467663ff1128",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "generator",
      "external_id": "false",
      "title": "Computer Lab with Printing",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1cb23369bef568a3015bd6bf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "generator",
      "external_id": "false",
      "title": "Fitness Studio with Fitness on Demand",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_093c17cc4d34f3953813e39d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "generator",
      "external_id": "false",
      "title": "Game Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7c8cdf1bbbc77cfe519239cf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "generator",
      "external_id": "false",
      "title": "Half‑sized Basketball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ff4fedbb10f1adcac2e72b0d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "generator",
      "external_id": "false",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f6f408f50560d420b2e2b0d4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "generator",
      "external_id": "false",
      "title": "Outdoor Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_16c2d507ea391b5aaba41347",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "generator",
      "external_id": "false",
      "title": "Pet Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cca9a0a5d7a4a0fd167eb4ac",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "generator",
      "external_id": "false",
      "title": "Resident Events",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c1f8b7f336aa876ff52e2aab",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "generator",
      "external_id": "false",
      "title": "Resort‑style Pool with Lounge Seating",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4ba04ed552edcf2de6e97054",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "generator",
      "external_id": "false",
      "title": "Sand Volleyball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_078b2a04d7f99505852ed5dd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "generator",
      "external_id": "false",
      "title": "Shared and Private Study Areas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_089346f0fdd7eab15965b69d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "generator",
      "external_id": "false",
      "title": "Shuttle to Campus – 0.7 miles away",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5b1f29b3df9bbcc12bc09356",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "generator",
      "external_id": "false",
      "title": "Balcony or Patio",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e9f32447d06f7748a2f106a7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "generator",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a2354b72d3894a3ac68288d7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "generator",
      "external_id": "false",
      "title": "Furnished Available*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1b3a3b2801e7f4223cf0ca0b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "generator",
      "external_id": "false",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b625072bcaa04192396a041e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "generator",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_398c5ff627f01893149a9901",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "generator",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e392840384c2a3ee2386fc7f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "generator",
      "external_id": "false",
      "title": "Stainless Steel Appliances*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bd7eb3a9d70c3189c9eacad1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "generator",
      "external_id": "false",
      "title": "Valet Trash Pick‑up",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_614a3937874f1dfb981abde1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "generator",
      "external_id": "false",
      "title": "Washer and Dryer in Home",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_9320930a-681f-4734-bcb1-7d27502dfb6d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019fb377-e514-76fe-9db0-13945a4dfa6d.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabana.",
        "public_id": "019fb377-e514-76fe-9db0-13945a4dfa6d",
        "storage_key": "property/6737460151191766/019fb377-e514-76fe-9db0-13945a4dfa6d.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy our sparkling swimming pool, complete with comfortable lounge chairs and a shaded cabana area for relaxation.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and cabana.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c63fd521-7ca2-4b42-b57d-9a1ea7d2f3f9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019fb377-e402-75d8-a164-295ac405e4ae.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, granite countertops, stainless steel appliances including a refrigerator, microwave, and stove.",
        "public_id": "019fb377-e402-75d8-a164-295ac405e4ae",
        "storage_key": "property/6737460151191766/019fb377-e402-75d8-a164-295ac405e4ae.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Apartment",
      "description": "A modern and functional kitchen featuring white cabinetry, granite countertops, and a full suite of stainless steel appliances, perfect for any home chef.",
      "link": "",
      "alt_text": "Kitchen with white cabinets, granite countertops, stainless steel appliances including a refrigerator, microwave, and stove.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d67a6ef4-b000-4984-a931-06f44a5ea35f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019fb377-e3f6-7723-8fdd-b4f8158a7d3b.webp",
      "image_media": {
        "alt_text": "Dining area with a round table and chairs, leading into a living room with a TV and a sofa.",
        "public_id": "019fb377-e3f6-7723-8fdd-b4f8158a7d3b",
        "storage_key": "property/6737460151191766/019fb377-e3f6-7723-8fdd-b4f8158a7d3b.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Enjoy meals and relax in this inviting dining and living area, perfect for entertaining or unwinding.",
      "link": "",
      "alt_text": "Dining area with a round table and chairs, leading into a living room with a TV and a sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_86220906-5301-4a09-a62f-556727b36774",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e8497-c2af-763b-915a-6b818466378c.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen area with stylish furniture and decor.",
        "public_id": "019e8497-c2af-763b-915a-6b818466378c",
        "storage_key": "property/6737460151191766/019e8497-c2af-763b-915a-6b818466378c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy the open-concept living space, perfect for entertaining or relaxing, seamlessly flowing into the modern kitchen.",
      "link": "",
      "alt_text": "Modern living room and kitchen area with stylish furniture and decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_de1d4f73-889e-4019-a7be-134f6d38d466",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019fb377-e54d-72b4-8d03-badc2bee2469.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, blue and white floral comforter, and a desk.",
        "public_id": "019fb377-e54d-72b4-8d03-badc2bee2469",
        "storage_key": "property/6737460151191766/019fb377-e54d-72b4-8d03-badc2bee2469.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Rest easy in this inviting bedroom, featuring a comfortable queen bed with a charming floral comforter and a convenient desk space.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, blue and white floral comforter, and a desk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_73c16266-1f4d-4877-bae2-4b9618491cdb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019fb377-e7b9-704f-9634-3b2365c5d939.webp",
      "image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, and dining area with table and chairs.",
        "public_id": "019fb377-e7b9-704f-9634-3b2365c5d939",
        "storage_key": "property/6737460151191766/019fb377-e7b9-704f-9634-3b2365c5d939.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious living area with a large sectional sofa, coffee table, and a separate dining nook. The open-concept design connects to a modern kitchen.",
      "link": "",
      "alt_text": "Living room with sectional sofa, coffee table, and dining area with table and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0340c815-2939-41ea-be3e-e711fadfca99",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019fb377-e862-7028-8aae-6dfa67cac035.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with seating and lounge furniture.",
        "public_id": "019fb377-e862-7028-8aae-6dfa67cac035",
        "storage_key": "property/6737460151191766/019fb377-e862-7028-8aae-6dfa67cac035.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy outdoor entertaining at the grilling station, complete with comfortable seating and lounge areas for relaxation.",
      "link": "",
      "alt_text": "Outdoor grilling area with seating and lounge furniture.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b78865dd-429c-4153-bfb0-99cea7789cc7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019fb377-e493-7568-846f-3109309b8bba.webp",
      "image_media": {
        "alt_text": "Rivers Edge at Carolina Stadium shuttle bus with 1, 2, 3 bedroom apartments advertised.",
        "public_id": "019fb377-e493-7568-846f-3109309b8bba",
        "storage_key": "property/6737460151191766/019fb377-e493-7568-846f-3109309b8bba.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "A shuttle bus for Rivers Edge apartments, which are advertised as 1, 2, and 3 bedroom apartments designed with Columbia students in mind.",
      "link": "",
      "alt_text": "Rivers Edge at Carolina Stadium shuttle bus with 1, 2, 3 bedroom apartments advertised.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_90058d99-514a-4bc8-abdf-6d0ef2a96234",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e8497-af79-77a7-acc9-08d735090f8b.webp",
      "image_media": {
        "alt_text": "Communal lounge with seating areas, a full-service bar, and entertainment amenities.",
        "public_id": "019e8497-af79-77a7-acc9-08d735090f8b",
        "storage_key": "property/6737460151191766/019e8497-af79-77a7-acc9-08d735090f8b.webp",
        "width": 3072,
        "height": 2055
      },
      "title": "Community",
      "description": "Enjoy the vibrant community spaces, perfect for socializing or relaxing. Features include a bar area, comfortable seating, and entertainment options like a pool table.",
      "link": "",
      "alt_text": "Communal lounge with seating areas, a full-service bar, and entertainment amenities.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f7923019-9ef5-40bc-87c0-419754b37b66",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e8496-c299-7764-b22d-f626a3766190.webp",
      "image_media": {
        "alt_text": "Gym with cardio machines, weight machines, and exercise balls.",
        "public_id": "019e8496-c299-7764-b22d-f626a3766190",
        "storage_key": "property/6737460151191766/019e8496-c299-7764-b22d-f626a3766190.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with a variety of cardio and strength training equipment.",
      "link": "",
      "alt_text": "Gym with cardio machines, weight machines, and exercise balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_aa6cd06a-8cb4-4e4e-ba0c-cabe1741fc71",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e8497-97fb-735c-a840-842c4db203e5.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and wood-look flooring.",
        "public_id": "019e8497-97fb-735c-a840-842c4db203e5",
        "storage_key": "property/6737460151191766/019e8497-97fb-735c-a840-842c4db203e5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Chic and functional kitchen featuring ample cabinet space, granite countertops, a stainless steel refrigerator, and a sleek range. Perfect for culinary creations.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_19224d0f-60a9-4e61-9fc2-e0d8e77cb273",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019fb377-e60c-70e8-a26d-44bcdb8a174c.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, desk, and dresser.",
        "public_id": "019fb377-e60c-70e8-a26d-44bcdb8a174c",
        "storage_key": "property/6737460151191766/019fb377-e60c-70e8-a26d-44bcdb8a174c.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Relax in this inviting bedroom featuring a comfortable queen-size bed, a functional workspace with a desk and chair, and ample storage with a dresser.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, desk, and dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d9d8e91c-4049-4100-a482-74bd683db8d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e8497-7d85-7669-bfd8-b449a85a142e.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, a desk, and artwork.",
        "public_id": "019e8497-7d85-7669-bfd8-b449a85a142e",
        "storage_key": "property/6737460151191766/019e8497-7d85-7669-bfd8-b449a85a142e.webp",
        "width": 3072,
        "height": 1990
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable queen-size bed, a functional desk area, and tasteful wall art for a relaxing atmosphere.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, a desk, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_05e6fe89-a7cc-478a-8c3e-b2fcea5c2715",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019fb377-e4b9-736a-8157-594e41b88790.webp",
      "image_media": {
        "alt_text": "Bathroom with storage shelves, vanity, toilet, and bathtub with shower curtain.",
        "public_id": "019fb377-e4b9-736a-8157-594e41b88790",
        "storage_key": "property/6737460151191766/019fb377-e4b9-736a-8157-594e41b88790.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring ample storage, a modern vanity, toilet, and a bathtub with a blue and white striped shower curtain.",
      "link": "",
      "alt_text": "Bathroom with storage shelves, vanity, toilet, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dce2df84-8453-4db5-a6ba-3b0f56271a60",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e8497-986a-754d-8480-ae6fe5f2328e.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, sink, toilet, and bathtub with shower curtain.",
        "public_id": "019e8497-986a-754d-8480-ae6fe5f2328e",
        "storage_key": "property/6737460151191766/019e8497-986a-754d-8480-ae6fe5f2328e.webp",
        "width": 3072,
        "height": 1957
      },
      "title": "Apartment",
      "description": "Stylish and functional bathroom featuring a clean white vanity with ample counter space, a modern sink, and a bathtub with a white shower curtain. Perfect for relaxation.",
      "link": "",
      "alt_text": "Modern bathroom with white vanity, sink, toilet, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5b07c16c-3f56-41c6-a297-0382b82577fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e8496-c1af-731e-8262-867c2554964d.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabanas.",
        "public_id": "019e8496-c1af-731e-8262-867c2554964d",
        "storage_key": "property/6737460151191766/019e8496-c1af-731e-8262-867c2554964d.webp",
        "width": 2400,
        "height": 1600
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, perfect for relaxing and soaking up the sun. Lounge chairs and cabanas are available for your comfort.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and cabanas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2673e1f1-daad-4285-8588-b75fa2014481",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f777-74d9-b374-6caa4020704d.webp",
      "image_media": {
        "alt_text": "Resort-style pool with lounge chairs and cabana.",
        "public_id": "019e1e2c-f777-74d9-b374-6caa4020704d",
        "storage_key": "property/6737460151191766/019e1e2c-f777-74d9-b374-6caa4020704d.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our resort-style pool, surrounded by comfortable lounge chairs and a shaded cabana.",
      "link": "",
      "alt_text": "Resort-style pool with lounge chairs and cabana.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b1fcaebc-c9d7-4b99-8a81-4e253ba23ed9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f0e4-772b-9c6f-f16cf229391d.webp",
      "image_media": {
        "alt_text": "Community lounge area with a pool table, fireplace, and seating.",
        "public_id": "019e1e2c-f0e4-772b-9c6f-f16cf229391d",
        "storage_key": "property/6737460151191766/019e1e2c-f0e4-772b-9c6f-f16cf229391d.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy our spacious community lounge, featuring a pool table, modern fireplace, and comfortable seating areas for relaxation and socializing.",
      "link": "",
      "alt_text": "Community lounge area with a pool table, fireplace, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_91603bcc-25c2-4aef-bc0f-cc4eb78998a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e8497-98e8-7479-8ab4-6a27d41227a2.webp",
      "image_media": {
        "alt_text": "Gym with treadmills and weight machines, overlooking a swimming pool.",
        "public_id": "019e8497-98e8-7479-8ab4-6a27d41227a2",
        "storage_key": "property/6737460151191766/019e8497-98e8-7479-8ab4-6a27d41227a2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with treadmills, elliptical machines, and a full range of weight training equipment. Enjoy your workout with a view of the sparkling outdoor pool.",
      "link": "",
      "alt_text": "Gym with treadmills and weight machines, overlooking a swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_372382a7-5dde-40a0-b9ab-ec394f2b4f94",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e8497-a3c7-76c9-a81e-180ec61f9415.webp",
      "image_media": {
        "alt_text": "Fitness room with cardio machines and a TV.",
        "public_id": "019e8497-a3c7-76c9-a81e-180ec61f9415",
        "storage_key": "property/6737460151191766/019e8497-a3c7-76c9-a81e-180ec61f9415.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with cardio machines and a large TV for your entertainment.",
      "link": "",
      "alt_text": "Fitness room with cardio machines and a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e8e4dcaa-7caa-455f-a1d3-665318cd921c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e8497-bdaa-725b-b144-c44d605f97c9.webp",
      "image_media": {
        "alt_text": "A conference room with a table, chairs, a TV, and a whiteboard.",
        "public_id": "019e8497-bdaa-725b-b144-c44d605f97c9",
        "storage_key": "property/6737460151191766/019e8497-bdaa-725b-b144-c44d605f97c9.webp",
        "width": 3072,
        "height": 2017
      },
      "title": "Community",
      "description": "A modern conference room featuring a large table, comfortable seating, a flat-screen TV for presentations, and a whiteboard for brainstorming.",
      "link": "",
      "alt_text": "A conference room with a table, chairs, a TV, and a whiteboard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ec388d0b-53af-4f54-8594-a035d5667abd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e8497-425c-7088-bb6d-9c2514150a29.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and a modern building.",
        "public_id": "019e8497-425c-7088-bb6d-9c2514150a29",
        "storage_key": "property/6737460151191766/019e8497-425c-7088-bb6d-9c2514150a29.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Relax by the sparkling resort-style swimming pool, complete with comfortable lounge chairs and a beautifully landscaped patio area. Adjacent to the clubhouse, this is the perfect spot to unwind and enjoy the Florida sunshine.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and a modern building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b472b332-ce8f-45a8-b761-c7dfb179fd8b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-a698-71c3-ae3e-9edd89390f4d.webp",
      "image_media": {
        "alt_text": "Apartment complex exterior with a sand volleyball court and benches on a sunny day.",
        "public_id": "019e1e2c-a698-71c3-ae3e-9edd89390f4d",
        "storage_key": "property/6737460151191766/019e1e2c-a698-71c3-ae3e-9edd89390f4d.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation at our apartment community with a sand volleyball court, perfect for friendly games on a sunny day.",
      "link": "",
      "alt_text": "Apartment complex exterior with a sand volleyball court and benches on a sunny day.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b5a4dbea-1655-436c-887b-61d6f5b5b2a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e8497-b2d5-7398-ab67-12b1c992c67d.webp",
      "image_media": {
        "alt_text": "Modern leasing office with desks, comfortable seating, and decorative green wall.",
        "public_id": "019e8497-b2d5-7398-ab67-12b1c992c67d",
        "storage_key": "property/6737460151191766/019e8497-b2d5-7398-ab67-12b1c992c67d.webp",
        "width": 3072,
        "height": 1978
      },
      "title": "Community",
      "description": "Welcome to our contemporary leasing office, featuring a stylish seating area with a unique green wall and sleek workstations. Perfect for consultations and resident services.",
      "link": "",
      "alt_text": "Modern leasing office with desks, comfortable seating, and decorative green wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cad7768f-e169-427c-bc28-e48ae33a0738",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e8497-b0bb-7723-be1b-88d3101a8f24.webp",
      "image_media": {
        "alt_text": "Community kitchen area with Pepsi vending machine, coffee maker, sink, and refrigerator.",
        "public_id": "019e8497-b0bb-7723-be1b-88d3101a8f24",
        "storage_key": "property/6737460151191766/019e8497-b0bb-7723-be1b-88d3101a8f24.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy convenient amenities in our community kitchen, featuring a Pepsi vending machine, coffee station, and ample refrigerator space.",
      "link": "",
      "alt_text": "Community kitchen area with Pepsi vending machine, coffee maker, sink, and refrigerator.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cb605f25-1777-4292-8579-3bf4deb383b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e8497-b3de-771b-872c-21d4ae7d0f55.webp",
      "image_media": {
        "alt_text": "Business center with computers and printer",
        "public_id": "019e8497-b3de-771b-872c-21d4ae7d0f55",
        "storage_key": "property/6737460151191766/019e8497-b3de-771b-872c-21d4ae7d0f55.webp",
        "width": 3072,
        "height": 2055
      },
      "title": "Community",
      "description": "Stay productive in our community business center, featuring computers and a printer for resident use.",
      "link": "",
      "alt_text": "Business center with computers and printer",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7dc67408-163d-4b7d-9928-fc092c611e51",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-a649-70d2-b79b-b5eda1882417.webp",
      "image_media": {
        "alt_text": "Apartment buildings with manicured lawns, a walking path, and a bench.",
        "public_id": "019e1e2c-a649-70d2-b79b-b5eda1882417",
        "storage_key": "property/6737460151191766/019e1e2c-a649-70d2-b79b-b5eda1882417.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy the beautifully maintained grounds and walking paths at our community, perfect for a relaxing stroll.",
      "link": "",
      "alt_text": "Apartment buildings with manicured lawns, a walking path, and a bench.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b2639707-91c7-4f03-9e4e-0b889c06c4d8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e8497-937b-7314-8bce-2019f2486255.webp",
      "image_media": {
        "alt_text": "Aerial view of a swimming pool and clubhouse at a multifamily property.",
        "public_id": "019e8497-937b-7314-8bce-2019f2486255",
        "storage_key": "property/6737460151191766/019e8497-937b-7314-8bce-2019f2486255.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Enjoy the resort-style swimming pool and spacious clubhouse at this multifamily property. Perfect for relaxation and socializing.",
      "link": "",
      "alt_text": "Aerial view of a swimming pool and clubhouse at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_79af8158-9934-4f1f-9d3d-4d8100e80503",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e8497-85a9-75d2-98c0-2998f9ac3ed5.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen with grills and sink, adjacent to a pool and lounge area.",
        "public_id": "019e8497-85a9-75d2-98c0-2998f9ac3ed5",
        "storage_key": "property/6737460151191766/019e8497-85a9-75d2-98c0-2998f9ac3ed5.webp",
        "width": 3072,
        "height": 2055
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and relaxation with our community's built-in grills, sink, and nearby pool and lounge area.",
      "link": "",
      "alt_text": "Outdoor kitchen with grills and sink, adjacent to a pool and lounge area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c68a1480-509a-47f6-a658-40adbc85e023",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e8497-942b-776b-940e-b2b1696f2ea6.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a fitness center in the background.",
        "public_id": "019e8497-942b-776b-940e-b2b1696f2ea6",
        "storage_key": "property/6737460151191766/019e8497-942b-776b-940e-b2b1696f2ea6.webp",
        "width": 3072,
        "height": 2066
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, complete with comfortable lounge chairs and surrounded by lush palm trees. Adjacent to the pool is our state-of-the-art fitness center.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and a fitness center in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0a34851f-75a9-427e-8a28-0322ea36476a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e8496-c211-7269-9ddd-166630eb96e0.webp",
      "image_media": {
        "alt_text": "Gym equipment including weight machines, dumbbells, and a bench.",
        "public_id": "019e8496-c211-7269-9ddd-166630eb96e0",
        "storage_key": "property/6737460151191766/019e8496-c211-7269-9ddd-166630eb96e0.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring weight machines, free weights, and cardio equipment for residents.",
      "link": "",
      "alt_text": "Gym equipment including weight machines, dumbbells, and a bench.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_830b714c-e1ee-413a-9a0b-9f7356b4439b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2d-183e-7091-a68f-f6694ef49124.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019e1e2d-183e-7091-a68f-f6694ef49124",
        "storage_key": "property/6737460151191766/019e1e2d-183e-7091-a68f-f6694ef49124.webp",
        "width": 2400,
        "height": 1600
      },
      "title": "Community",
      "description": "Relax by the resort-style swimming pool, complete with comfortable lounge chairs and lush palm trees. Enjoy a refreshing dip or soak up the sun in this beautiful outdoor oasis.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b8522882-e5a2-4e51-8941-95f493e65033",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e8497-7d32-776a-97bc-16e80a66b133.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and surrounding lounge area with palm trees and apartment buildings.",
        "public_id": "019e8497-7d32-776a-97bc-16e80a66b133",
        "storage_key": "property/6737460151191766/019e8497-7d32-776a-97bc-16e80a66b133.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Enjoy our sparkling outdoor swimming pool and sun deck, perfect for relaxation and outdoor gatherings. Surrounded by lush landscaping and comfortable seating.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool and surrounding lounge area with palm trees and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cb2dc543-98bb-4f60-82bd-1825f7a62d2e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e8497-7ca0-744c-be5b-e66ea8e2e3b5.webp",
      "image_media": {
        "alt_text": "Clubhouse entrance with parking lot and palm trees.",
        "public_id": "019e8497-7ca0-744c-be5b-e66ea8e2e3b5",
        "storage_key": "property/6737460151191766/019e8497-7ca0-744c-be5b-e66ea8e2e3b5.webp",
        "width": 3072,
        "height": 1990
      },
      "title": "Community",
      "description": "The clubhouse at this apartment community features a welcoming entrance and ample parking.",
      "link": "",
      "alt_text": "Clubhouse entrance with parking lot and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_39a7fe32-052d-4bec-ba99-5150a5e8c1b5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e8497-653e-738e-a54e-038853926603.webp",
      "image_media": {
        "alt_text": "Aerial view of a baseball stadium with a city skyline and river in the background.",
        "public_id": "019e8497-653e-738e-a54e-038853926603",
        "storage_key": "property/6737460151191766/019e8497-653e-738e-a54e-038853926603.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Aerial perspective of a baseball stadium nestled amongst trees, with a river and cityscape visible in the distance. Captures the vibrancy of the surrounding community.",
      "link": "",
      "alt_text": "Aerial view of a baseball stadium with a city skyline and river in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2ad65523-70f5-4d5c-bf15-72df1f44c688",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e8497-6315-763a-9887-bb050ade8c52.webp",
      "image_media": {
        "alt_text": "Clubhouse building with parking lot and palm trees",
        "public_id": "019e8497-6315-763a-9887-bb050ade8c52",
        "storage_key": "property/6737460151191766/019e8497-6315-763a-9887-bb050ade8c52.webp",
        "width": 3072,
        "height": 1991
      },
      "title": "Community",
      "description": "The clubhouse building for the community, featuring a welcoming entrance and ample parking.",
      "link": "",
      "alt_text": "Clubhouse building with parking lot and palm trees",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_86d9623d-05fa-4b83-a623-f51acb0768fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e8496-e0ae-75fd-91f3-ec76d377a99c.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool and clubhouse area.",
        "public_id": "019e8496-e0ae-75fd-91f3-ec76d377a99c",
        "storage_key": "property/6737460151191766/019e8496-e0ae-75fd-91f3-ec76d377a99c.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Enjoy the resort-style swimming pool and clubhouse area, perfect for relaxation and socializing.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool and clubhouse area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8932cf7d-f7be-4add-9b64-b09255ef6f4f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2d-038d-77cf-938a-b3036b6e4e45.webp",
      "image_media": {
        "alt_text": "Row of lounge chairs and cabanas by an outdoor swimming pool.",
        "public_id": "019e1e2d-038d-77cf-938a-b3036b6e4e45",
        "storage_key": "property/6737460151191766/019e1e2d-038d-77cf-938a-b3036b6e4e45.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded cabanas.",
      "link": "",
      "alt_text": "Row of lounge chairs and cabanas by an outdoor swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_33c728bb-d6f6-484c-8301-2e5d147ed1d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-e372-74cb-a5d0-0a6c48274a48.webp",
      "image_media": {
        "alt_text": "Lobby seating area with view of the pool",
        "public_id": "019e1e2c-e372-74cb-a5d0-0a6c48274a48",
        "storage_key": "property/6737460151191766/019e1e2c-e372-74cb-a5d0-0a6c48274a48.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and unwind in our comfortable lobby seating area, with a view overlooking the sparkling outdoor pool and lush landscaping.",
      "link": "",
      "alt_text": "Lobby seating area with view of the pool",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_27f4705c-9fc3-4eee-b4a1-77e0138371b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-dcff-75ba-9897-e18d2fd32335.webp",
      "image_media": {
        "alt_text": "Business center with computers, printer, and seating.",
        "public_id": "019e1e2c-dcff-75ba-9897-e18d2fd32335",
        "storage_key": "property/6737460151191766/019e1e2c-dcff-75ba-9897-e18d2fd32335.webp",
        "width": 1920,
        "height": 1284
      },
      "title": "Community",
      "description": "Stay productive in our community business center, featuring computers, a printer, and comfortable seating.",
      "link": "",
      "alt_text": "Business center with computers, printer, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_810b2df2-3b6c-4885-bfef-3bdd410f277c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-c82e-719f-bd8d-b109e83a7e5a.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment and picnic table outside apartment building.",
        "public_id": "019e1e2c-c82e-719f-bd8d-b109e83a7e5a",
        "storage_key": "property/6737460151191766/019e1e2c-c82e-719f-bd8d-b109e83a7e5a.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy our community dog park, complete with agility equipment and picnic tables for owners. A great place for your furry friends to play and socialize.",
      "link": "",
      "alt_text": "Dog park with agility equipment and picnic table outside apartment building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ade6f501-09a9-4a19-998e-6614ee3d1981",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-c833-731e-bcf8-6ec704c08b54.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and outdoor stairs.",
        "public_id": "019e1e2c-c833-731e-bcf8-6ec704c08b54",
        "storage_key": "property/6737460151191766/019e1e2c-c833-731e-bcf8-6ec704c08b54.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Spacious apartment buildings with well-maintained exteriors, offering balconies and convenient outdoor access.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and outdoor stairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7cdcedc1-24bc-4482-80d4-299e6466ccee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-c835-76cc-9e46-a25d70671a4c.webp",
      "image_media": {
        "alt_text": "Exterior of a beige apartment building with balconies and manicured landscaping.",
        "public_id": "019e1e2c-c835-76cc-9e46-a25d70671a4c",
        "storage_key": "property/6737460151191766/019e1e2c-c835-76cc-9e46-a25d70671a4c.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Spacious apartment building exterior featuring private balconies and lush green grounds. Offers a welcoming community atmosphere.",
      "link": "",
      "alt_text": "Exterior of a beige apartment building with balconies and manicured landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_86e8d782-f0ea-4b53-91bc-077484f55188",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-b82b-7757-b74f-44a0ee2bd466.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with manicured lawns and blue sky.",
        "public_id": "019e1e2c-b82b-7757-b74f-44a0ee2bd466",
        "storage_key": "property/6737460151191766/019e1e2c-b82b-7757-b74f-44a0ee2bd466.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Charming apartment buildings with exterior staircases and balconies, set against a backdrop of lush green lawns and a clear blue sky.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with manicured lawns and blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_344cc89d-21e6-40d1-8197-d6bfc055c0ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019fb377-e514-76fe-9db0-0d64e0f62f87.webp",
      "image_media": {
        "alt_text": "Hammock area with palm trees and picnic table outside apartment buildings.",
        "public_id": "019fb377-e514-76fe-9db0-0d64e0f62f87",
        "storage_key": "property/6737460151191766/019fb377-e514-76fe-9db0-0d64e0f62f87.webp",
        "width": 1999,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and unwind in our hammock garden, surrounded by lush palm trees. Enjoy a picnic lunch at the nearby table.",
      "link": "",
      "alt_text": "Hammock area with palm trees and picnic table outside apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_c668d15c-0cde-4673-8c5c-3ffbf706d951",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "J's Corner Restaurant & Bar",
      "poi_type": "Restaurants",
      "poi_address": "1015 Rosewood Dr, Columbia, SC 29201, USA",
      "poi_short_description": "Hearty comfort food & draft beer in an airy former gas station with ample outdoor seating.",
      "poi_long_description": "Hearty comfort food & draft beer in an airy former gas station with ample outdoor seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-2c2b-709c-8468-ce19403cb998.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-2c2b-709c-8468-ce19403cb998",
        "storage_key": "property/6737460151191766/019e1e2e-2c2b-709c-8468-ce19403cb998.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.jscornersc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6006146630767589855&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "js-corner-restaurant--bar",
      "poi_latitude": "33.9766938",
      "poi_longitude": "-81.0252138",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 803-862-0702",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bb-70de-82c1-f99e154c6890.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bb-70de-82c1-f99e154c6890",
        "storage_key": "property/6737460151191766/019e1e2c-f6bb-70de-82c1-f99e154c6890.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRRATFPO7-IgR37nP64keWlM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_548e2cda-54d7-446d-a3e8-e227001d7a98",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Saluda's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "751 Saluda Ave, Columbia, SC 29205, USA",
      "poi_short_description": "Upscale spot serving reimagined Southern classics with white-linen tables & an antique mahogany bar.",
      "poi_long_description": "Upscale spot serving reimagined Southern classics with white-linen tables & an antique mahogany bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-2d45-743f-bd06-e31d49e00f3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-2d45-743f-bd06-e31d49e00f3e",
        "storage_key": "property/6737460151191766/019e1e2e-2d45-743f-bd06-e31d49e00f3e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.saludas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5214153063177084582&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saludas-restaurant",
      "poi_latitude": "33.999807",
      "poi_longitude": "-81.017225",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-799-9500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bb-70de-82c1-f99e154c6890.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bb-70de-82c1-f99e154c6890",
        "storage_key": "property/6737460151191766/019e1e2c-f6bb-70de-82c1-f99e154c6890.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwbsVIsy6-IgRpl4vz5VkXEg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_7e1ec4aa-1cd1-4cb9-ab94-08d2e04bcd39",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Drip Coffee",
      "poi_type": "Restaurants",
      "poi_address": "729 Saluda Ave, Columbia, SC 29205, USA",
      "poi_short_description": "Relaxed coffee shop serving pour-overs, lattes, and other drinks, plus small plates.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-2bf2-777b-a57a-393f363e61fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-2bf2-777b-a57a-393f363e61fa",
        "storage_key": "property/6737460151191766/019e1e2e-2bf2-777b-a57a-393f363e61fa.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://dripcolumbia.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15094232725474880216&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "drip-coffee",
      "poi_latitude": "33.9992336",
      "poi_longitude": "-81.01733569999999",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-661-9545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-85b8-76c0-aaa6-14fdaf4b8b38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-85b8-76c0-aaa6-14fdaf4b8b38",
        "storage_key": "property/6737460151191766/019e1e2e-85b8-76c0-aaa6-14fdaf4b8b38.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJP0oBU8y6-IgR2KoB77B8edE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_ca21341e-9d4d-470b-b9bc-6f23fb66a82e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Groucho's Deli",
      "poi_type": "Restaurants",
      "poi_address": "611 Harden St, Columbia, SC 29205, USA",
      "poi_short_description": "Chain restaurant known for classic deli sandwiches & signature sides such as potato salad.",
      "poi_long_description": "Chain restaurant known for classic deli sandwiches & signature sides such as potato salad.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-2ccf-76bf-af69-766578c59bc2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-2ccf-76bf-af69-766578c59bc2",
        "storage_key": "property/6737460151191766/019e1e2e-2ccf-76bf-af69-766578c59bc2.webp",
        "width": 768,
        "height": 604
      },
      "poi_business_url": "https://www.grouchos.com/locations/5-points",
      "poi_directions_map_url": "https://maps.google.com/?cid=2469804485023795500&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grouchos-deli",
      "poi_latitude": "33.997829",
      "poi_longitude": "-81.0157144",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 877-207-7113",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f321-7739-aa86-227d3db205c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f321-7739-aa86-227d3db205c7",
        "storage_key": "property/6737460151191766/019e1e2c-f321-7739-aa86-227d3db205c7.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJIx5hEcy6-IgRLImC8heCRiI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "deli"
    },
    {
      "id": "custom_464498ae-00de-4a6b-b1c9-b4ce5e9ba70c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Village Idiot Pizza",
      "poi_type": "Restaurants",
      "poi_address": "2009 Devine St, Columbia, SC 29205, USA",
      "poi_short_description": "Unpretentious eatery with a create-your-own pizzas, grinders & other casual staples.",
      "poi_long_description": "Unpretentious eatery with a create-your-own pizzas, grinders & other casual staples.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-30bf-72e6-ac11-5f7acbc733fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-30bf-72e6-ac11-5f7acbc733fe",
        "storage_key": "property/6737460151191766/019e1e2e-30bf-72e6-ac11-5f7acbc733fe.webp",
        "width": 719,
        "height": 1280
      },
      "poi_business_url": "https://villageidiotpizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2750017417886294867&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "village-idiot-pizza",
      "poi_latitude": "33.9987716",
      "poi_longitude": "-81.01683039999999",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-252-8646",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bb-70de-82c1-f99e154c6890.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bb-70de-82c1-f99e154c6890",
        "storage_key": "property/6737460151191766/019e1e2c-f6bb-70de-82c1-f99e154c6890.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJw7RtT8y6-IgRU-M_d0UGKiY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_cc747df5-e1b1-4328-a11c-7f7fc5100417",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Publico",
      "poi_type": "Restaurants",
      "poi_address": "2013 Greene St, Columbia, SC 29205, USA",
      "poi_short_description": "Casual, stylish eatery for craft beer, wine and cocktails, plus a patio and a brunch menu.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-2bed-7353-96b0-d7fcfe0fdbbd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-2bed-7353-96b0-d7fcfe0fdbbd",
        "storage_key": "property/6737460151191766/019e1e2e-2bed-7353-96b0-d7fcfe0fdbbd.webp",
        "width": 360,
        "height": 640
      },
      "poi_business_url": "https://www.publicokitchenandtap.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11804289038089698345&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publico",
      "poi_latitude": "34.0003955",
      "poi_longitude": "-81.01723580000001",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-661-9043",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bb-70de-82c1-f99e154c6890.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bb-70de-82c1-f99e154c6890",
        "storage_key": "property/6737460151191766/019e1e2c-f6bb-70de-82c1-f99e154c6890.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2-Gk_8y6-IgRKbxfnVZC0aM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_10b898b0-6207-421d-85e6-3baeca946a82",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Il Giorgione",
      "poi_type": "Restaurants",
      "poi_address": "2406 Devine St, Columbia, SC 29205, USA",
      "poi_short_description": "Gourmet thin-crust pizza, pasta & imported wine served in comfortable surrounds with patio seating.",
      "poi_long_description": "Gourmet thin-crust pizza, pasta & imported wine served in comfortable surrounds with patio seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-2ee1-71aa-b79a-9e9d991ca8aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-2ee1-71aa-b79a-9e9d991ca8aa",
        "storage_key": "property/6737460151191766/019e1e2e-2ee1-71aa-b79a-9e9d991ca8aa.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.ilgiorgione.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7820647172221069163&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "il-giorgione",
      "poi_latitude": "33.9983257",
      "poi_longitude": "-81.0102646",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 803-521-5063",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bb-70de-82c1-f99e154c6890.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bb-70de-82c1-f99e154c6890",
        "storage_key": "property/6737460151191766/019e1e2c-f6bb-70de-82c1-f99e154c6890.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-z4zb8q6-IgRa2fm5SqFiGw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_3d36f83d-d4c8-477d-b8b2-5f12e9ca0c74",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "The Flying Biscuit Cafe",
      "poi_type": "Restaurants",
      "poi_address": "936 Harden St, Columbia, SC 29205, USA",
      "poi_short_description": "Branch of a laid-back chain known for Southern food & all-day breakfast selections.",
      "poi_long_description": "Branch of a laid-back chain known for Southern food & all-day breakfast selections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-2d9c-762d-b116-90abfbf368f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-2d9c-762d-b116-90abfbf368f7",
        "storage_key": "property/6737460151191766/019e1e2e-2d9c-762d-b116-90abfbf368f7.webp",
        "width": 1169,
        "height": 659
      },
      "poi_business_url": "https://flyingbiscuit.com/locations-2/five-points/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8593710637084237033&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-flying-biscuit-cafe",
      "poi_latitude": "34.0030504",
      "poi_longitude": "-81.0173929",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 803-828-9458",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bb-70de-82c1-f99e154c6890.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bb-70de-82c1-f99e154c6890",
        "storage_key": "property/6737460151191766/019e1e2c-f6bb-70de-82c1-f99e154c6890.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ76qMMKOl-IgR6dzmAUv-Qnc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_8f705361-6c90-4178-83dc-9f7354ed56cc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Motor Supply Company Bistro",
      "poi_type": "Restaurants",
      "poi_address": "920 Gervais St, Columbia, SC 29201, USA",
      "poi_short_description": "Upscale American eatery with a daily changing menu, plus an outdoor sculpture garden.",
      "poi_long_description": "Upscale American eatery with a daily changing menu, plus an outdoor sculpture garden.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-3129-7643-bf96-86d7dc8a10cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-3129-7643-bf96-86d7dc8a10cc",
        "storage_key": "property/6737460151191766/019e1e2e-3129-7643-bf96-86d7dc8a10cc.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "http://www.motorsupplycobistro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1300887774481802294&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "motor-supply-company-bistro",
      "poi_latitude": "33.9998643",
      "poi_longitude": "-81.0374144",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 803-256-6687",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bb-70de-82c1-f99e154c6890.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bb-70de-82c1-f99e154c6890",
        "storage_key": "property/6737460151191766/019e1e2c-f6bb-70de-82c1-f99e154c6890.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1Ymxciy7-IgRNuSi2omuDRI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bistro"
    },
    {
      "id": "custom_6d862810-8951-49e5-8985-fe9141aa099e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Market On Main",
      "poi_type": "Restaurants",
      "poi_address": "1320 Main St #150, Columbia, SC 29201, USA",
      "poi_short_description": "Airy restaurant with a terrace offering classic burgers, steaks & salads, plus a store.",
      "poi_long_description": "Airy restaurant with a terrace offering classic burgers, steaks & salads, plus a store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-3572-7423-a91e-8a57fb0616a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-3572-7423-a91e-8a57fb0616a9",
        "storage_key": "property/6737460151191766/019e1e2e-3572-7423-a91e-8a57fb0616a9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.marketonmain.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2106512621627551176&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "market-on-main",
      "poi_latitude": "34.0032236",
      "poi_longitude": "-81.03401389999999",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-722-4222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bb-70de-82c1-f99e154c6890.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bb-70de-82c1-f99e154c6890",
        "storage_key": "property/6737460151191766/019e1e2c-f6bb-70de-82c1-f99e154c6890.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiQzk7ra7-IgRyK38jhHWOx0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_76ed2846-cdfb-480a-b975-ad109b3f52c3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Oyster Bar Columbia",
      "poi_type": "Restaurants",
      "poi_address": "1123 Park St, Columbia, SC 29201, USA",
      "poi_short_description": "Raw & steamed oysters, shrimp, scallops & beer are served at this simple local hangout.",
      "poi_long_description": "Raw & steamed oysters, shrimp, scallops & beer are served at this simple local hangout.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-3374-73aa-bdba-7e7928665e3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-3374-73aa-bdba-7e7928665e3d",
        "storage_key": "property/6737460151191766/019e1e2e-3374-73aa-bdba-7e7928665e3d.webp",
        "width": 480,
        "height": 360
      },
      "poi_business_url": "https://oysterbarcolumbia.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2087372014013843618&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oyster-bar-columbia",
      "poi_latitude": "33.9996636",
      "poi_longitude": "-81.03696850000001",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 803-799-4484",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bb-70de-82c1-f99e154c6890.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bb-70de-82c1-f99e154c6890",
        "storage_key": "property/6737460151191766/019e1e2c-f6bb-70de-82c1-f99e154c6890.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0Q429Su7-IgRoghjkcnV9xw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "oyster_bar_restaurant"
    },
    {
      "id": "custom_14c203c9-1dc8-42c2-b476-9210bc5c15d6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Halls Chophouse Columbia",
      "poi_type": "Restaurants",
      "poi_address": "1221 Main St #150, Columbia, SC 29201, USA",
      "poi_short_description": "Popular steakhouse serving choice cuts of beef & locally sourced seafood in sophisticated surrounds.",
      "poi_long_description": "Popular steakhouse serving choice cuts of beef & locally sourced seafood in sophisticated surrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-3587-7568-beeb-243be54a5f00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-3587-7568-beeb-243be54a5f00",
        "storage_key": "property/6737460151191766/019e1e2e-3587-7568-beeb-243be54a5f00.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://hallschophousecolumbia.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14980256746556419975&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "halls-chophouse-columbia",
      "poi_latitude": "34.0016423",
      "poi_longitude": "-81.0341773",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 803-563-5066",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bb-70de-82c1-f99e154c6890.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bb-70de-82c1-f99e154c6890",
        "storage_key": "property/6737460151191766/019e1e2c-f6bb-70de-82c1-f99e154c6890.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlQ0o4da7-IgRh--kZiSQ5M8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_5345739c-ff95-4a6c-a423-edeaf470ca0b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Cantina 76",
      "poi_type": "Restaurants",
      "poi_address": "1301 Main St, Columbia, SC 29201, USA",
      "poi_short_description": "Laid-back hangout known for choice margaritas & upmarket, contemporary tacos & Mexican entrees.",
      "poi_long_description": "Laid-back hangout known for choice margaritas & upmarket, contemporary tacos & Mexican entrees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-3d45-73ed-987a-b20b997ada40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-3d45-73ed-987a-b20b997ada40",
        "storage_key": "property/6737460151191766/019e1e2e-3d45-73ed-987a-b20b997ada40.webp",
        "width": 1280,
        "height": 831
      },
      "poi_business_url": "https://www.cantina76.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17097482813622876660&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cantina-76",
      "poi_latitude": "34.0027219",
      "poi_longitude": "-81.0344502",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 803-764-1769",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bb-70de-82c1-f99e154c6890.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bb-70de-82c1-f99e154c6890",
        "storage_key": "property/6737460151191766/019e1e2c-f6bb-70de-82c1-f99e154c6890.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM6XRICu7-IgR9HlWWwh2Ru0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "taco_restaurant"
    },
    {
      "id": "custom_ece71a89-925d-4717-8959-f290d3eeda4e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "The Devine Cinnamon Roll Deli",
      "poi_type": "Restaurants",
      "poi_address": "2617 Devine St, Columbia, SC 29223, USA",
      "poi_short_description": "Cinnamon-roll centric deli serving a brunch menu, sandwiches and breakfast dishes such as grits.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-3626-7248-9f4f-76e31a72af9a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-3626-7248-9f4f-76e31a72af9a",
        "storage_key": "property/6737460151191766/019e1e2e-3626-7248-9f4f-76e31a72af9a.webp",
        "width": 1215,
        "height": 556
      },
      "poi_business_url": "http://www.thecinnamonrolldeli.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10803321111250882561&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-devine-cinnamon-roll-deli",
      "poi_latitude": "33.9988055",
      "poi_longitude": "-81.006304",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 803-465-4947",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f321-7739-aa86-227d3db205c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f321-7739-aa86-227d3db205c7",
        "storage_key": "property/6737460151191766/019e1e2c-f321-7739-aa86-227d3db205c7.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJR0bsUrS6-IgRAVCW7k8b7ZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "deli"
    },
    {
      "id": "custom_7d1ed51d-f889-4fe6-aa14-9f7e4a4b3d24",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Publix Super Market at Gervais Place",
      "poi_type": "Shopping & Retail",
      "poi_address": "501 Gervais St, Columbia, SC 29201, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-7a1b-72ea-be96-281834e1f05b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-7a1b-72ea-be96-281834e1f05b",
        "storage_key": "property/6737460151191766/019e1e2c-7a1b-72ea-be96-281834e1f05b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1095&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=2017290577663954272&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-gervais-place",
      "poi_latitude": "33.9983389",
      "poi_longitude": "-81.04446659999999",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 803-255-4351",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f31c-74ff-b052-d01f49777b9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f31c-74ff-b052-d01f49777b9a",
        "storage_key": "property/6737460151191766/019e1e2c-f31c-74ff-b052-d01f49777b9a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF1Q4nDG7-IgRYA1nohfb_hs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_51f4af80-aa1d-4df9-88a9-1a23c9147d1d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Food Lion",
      "poi_type": "Shopping & Retail",
      "poi_address": "1001 Harden St, Columbia, SC 29205, USA",
      "poi_short_description": "Clean supermarket with a deli, bakery and meat department as well as self-checkout registers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-3812-750e-a53b-a2fcf3734350.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-3812-750e-a53b-a2fcf3734350",
        "storage_key": "property/6737460151191766/019e1e2e-3812-750e-a53b-a2fcf3734350.webp",
        "width": 1280,
        "height": 869
      },
      "poi_business_url": "https://stores.foodlion.com/sc/columbia/1001-harden-street?y_source=1_NTA0NjkxMy03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=23964264729376161&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "food-lion",
      "poi_latitude": "34.0032384",
      "poi_longitude": "-81.0188457",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 803-748-8104",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f31c-74ff-b052-d01f49777b9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f31c-74ff-b052-d01f49777b9a",
        "storage_key": "property/6737460151191766/019e1e2c-f31c-74ff-b052-d01f49777b9a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJob63yzKl-IgRoXV_Ll8jVQA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_57dd7b98-d164-4e75-a17e-7caf65a58db1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Amoco",
      "poi_type": "Shopping & Retail",
      "poi_address": "1421 Gervais St, Columbia, SC 29201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-3a30-75cd-b2e2-7d43a429d8e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-3a30-75cd-b2e2-7d43a429d8e5",
        "storage_key": "property/6737460151191766/019e1e2e-3a30-75cd-b2e2-7d43a429d8e5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://map.bp.com/en-US/US/gas-station/columbia/amoco/96332900584212920100100000000000",
      "poi_directions_map_url": "https://maps.google.com/?cid=7140992606308452891&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amoco",
      "poi_latitude": "34.0029796",
      "poi_longitude": "-81.0291836",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-799-0217",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-85d4-74e8-b35f-2e7255fbb2ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-85d4-74e8-b35f-2e7255fbb2ae",
        "storage_key": "property/6737460151191766/019e1e2e-85d4-74e8-b35f-2e7255fbb2ae.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJi61y36-7-IgRG8q02vDmGWM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_ac2163bc-81a6-4a35-b5df-e7d779cb1df2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "College Mart",
      "poi_type": "Shopping & Retail",
      "poi_address": "2100 Devine St A, Columbia, SC 29205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-3c1e-76f9-b06a-274d62e13db9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-3c1e-76f9-b06a-274d62e13db9",
        "storage_key": "property/6737460151191766/019e1e2e-3c1e-76f9-b06a-274d62e13db9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2739626061525364562&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "college-mart",
      "poi_latitude": "33.9986513",
      "poi_longitude": "-81.0153998",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-256-0986",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-85a0-710d-b168-73837283737e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-85a0-710d-b168-73837283737e",
        "storage_key": "property/6737460151191766/019e1e2e-85a0-710d-b168-73837283737e.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJK0Akbsy6-IgRUi-fRmMbBSY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_7887d73f-525c-4076-8460-690cb1f400ad",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "1941 Blossom St Walgreens, Columbia, SC 29205, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-3e00-749e-8818-8725451b3eb4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-3e00-749e-8818-8725451b3eb4",
        "storage_key": "property/6737460151191766/019e1e2e-3e00-749e-8818-8725451b3eb4.webp",
        "width": 1280,
        "height": 1245
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1941+blossom+st-columbia-sc-29205/id=11433",
      "poi_directions_map_url": "https://maps.google.com/?cid=17093135889091980123&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "33.9980895",
      "poi_longitude": "-81.0170352",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-212-1015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bc-727d-80fb-44f8b25f3f87",
        "storage_key": "property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNyqSNMy6-IgRW-vOHocEN-0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_c7a340a8-e521-4887-af51-aadd33d00bd3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "The Gourmet Shop",
      "poi_type": "Shopping & Retail",
      "poi_address": "724 Saluda Ave, Columbia, SC 29205, USA",
      "poi_short_description": "Upscale grocery with outdoor dining offering gourmet items, prepared foods, coffee, wine & cheeses.",
      "poi_long_description": "Upscale grocery with outdoor dining offering gourmet items, prepared foods, coffee, wine & cheeses.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-3129-7643-bf96-8a6ad5e09eb3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-3129-7643-bf96-8a6ad5e09eb3",
        "storage_key": "property/6737460151191766/019e1e2e-3129-7643-bf96-8a6ad5e09eb3.webp",
        "width": 1263,
        "height": 1280
      },
      "poi_business_url": "https://www.thegourmetshop.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13382680588182953141&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-gourmet-shop",
      "poi_latitude": "33.9992266",
      "poi_longitude": "-81.0169307",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-799-3705",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-85b8-76c0-aaa6-14fdaf4b8b38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-85b8-76c0-aaa6-14fdaf4b8b38",
        "storage_key": "property/6737460151191766/019e1e2e-85b8-76c0-aaa6-14fdaf4b8b38.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJGZr6Ucy6-IgRtRwpKRfVuLk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_72541181-70ee-4d94-a7df-2a77f68838ba",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Uptown Gifts",
      "poi_type": "Shopping & Retail",
      "poi_address": "745 Saluda Ave, Columbia, SC 29205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-413d-777c-bbda-a13098178843.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-413d-777c-bbda-a13098178843",
        "storage_key": "property/6737460151191766/019e1e2e-413d-777c-bbda-a13098178843.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.uptownsc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12577657683151473323&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uptown-gifts",
      "poi_latitude": "33.9996213",
      "poi_longitude": "-81.0171749",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-661-7651",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f321-7739-aa86-227d3db205c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f321-7739-aa86-227d3db205c7",
        "storage_key": "property/6737460151191766/019e1e2c-f321-7739-aa86-227d3db205c7.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJk0WL7yq7-IgRq8q0BgbRjK4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gift_shop"
    },
    {
      "id": "custom_0932f76d-4b71-4598-a8a1-f9b94cac962a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Staples",
      "poi_type": "Shopping & Retail",
      "poi_address": "4464 Devine St, Columbia, SC 29205, USA",
      "poi_short_description": "Chain retailer offering brand-name electronics & print services, plus office supplies & furniture.",
      "poi_long_description": "Chain retailer offering brand-name electronics & print services, plus office supplies & furniture.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-475d-704c-808c-f48740976e77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-475d-704c-808c-f48740976e77",
        "storage_key": "property/6737460151191766/019e1e2e-475d-704c-808c-f48740976e77.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://stores.staples.com/sc/columbia/4464-devine-st?cmpid=st_ll_goo&cid=LS:RETAIL:G&utm_source=google&utm_medium=organic&utm_campaign=Google_Business_Listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=5517350209565926239&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "staples",
      "poi_latitude": "33.9898129",
      "poi_longitude": "-80.9766466",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 803-787-5916",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f321-7739-aa86-227d3db205c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f321-7739-aa86-227d3db205c7",
        "storage_key": "property/6737460151191766/019e1e2c-f321-7739-aa86-227d3db205c7.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJmwDXNwWw-IgRX6OajsiQkUw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_128607e4-380e-4037-8b02-ff0b77c8680c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Papa Jazz Record Shoppe",
      "poi_type": "Shopping & Retail",
      "poi_address": "2014 Greene St, Columbia, SC 29205, USA",
      "poi_short_description": "Veteran store stocking new and used music in a variety of formats.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-470e-706f-b4f4-cfe6a9e12438.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-470e-706f-b4f4-cfe6a9e12438",
        "storage_key": "property/6737460151191766/019e1e2e-470e-706f-b4f4-cfe6a9e12438.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "http://papajazz.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2358896220814375763&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "papa-jazz-record-shoppe",
      "poi_latitude": "33.9998513",
      "poi_longitude": "-81.01735599999999",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-256-0095",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bc-727d-80fb-44f8b25f3f87",
        "storage_key": "property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6zC--8y6-IgRU_umZ517vCA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_e196b513-7f6f-4308-9eca-a2c9ea9715c0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "University of South Carolina",
      "poi_type": "Education",
      "poi_address": "1501 Pendleton St, Columbia, SC 29208, USA",
      "poi_short_description": "Founded in 1801, this school features historic buildings & museums on its 218-acre campus.",
      "poi_long_description": "Founded in 1801, this school features historic buildings & museums on its 218-acre campus.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-7bf9-77d2-9765-6c485b43211f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-7bf9-77d2-9765-6c485b43211f",
        "storage_key": "property/6737460151191766/019e1e2c-7bf9-77d2-9765-6c485b43211f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://sc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8700236860325688654&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-south-carolina",
      "poi_latitude": "33.99488420000001",
      "poi_longitude": "-81.028503",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 803-777-0169",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f400-75ad-b8a3-4412839dc9cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f400-75ad-b8a3-4412839dc9cd",
        "storage_key": "property/6737460151191766/019e1e2c-f400-75ad-b8a3-4412839dc9cd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG6ayLCi7-IgRTvV4IVRzvXg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_3e3fdd9b-b631-4b73-b19a-bee0e45f6250",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Benedict College",
      "poi_type": "Education",
      "poi_address": "1600 Harden St, Columbia, SC 29204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-7c19-727b-a9d7-84bf316a3ed8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-7c19-727b-a9d7-84bf316a3ed8",
        "storage_key": "property/6737460151191766/019e1e2c-7c19-727b-a9d7-84bf316a3ed8.webp",
        "width": 1280,
        "height": 966
      },
      "poi_business_url": "http://www.benedict.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=980414326126798695&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "benedict-college",
      "poi_latitude": "34.01302",
      "poi_longitude": "-81.0195629",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 803-253-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f400-75ad-b8a3-4412839dc9cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f400-75ad-b8a3-4412839dc9cd",
        "storage_key": "property/6737460151191766/019e1e2c-f400-75ad-b8a3-4412839dc9cd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB0EqCDCl-IgRZ-d9maIhmw0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_ced0c68e-4369-4fe4-8782-9ffdb2a72e7c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Columbia College",
      "poi_type": "Education",
      "poi_address": "1301 Columbia College Dr, Columbia, SC 29203, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-7e59-7319-a136-76999efa0636.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-7e59-7319-a136-76999efa0636",
        "storage_key": "property/6737460151191766/019e1e2c-7e59-7319-a136-76999efa0636.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://columbiasc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10898410972576538707&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "columbia-college",
      "poi_latitude": "34.045537",
      "poi_longitude": "-81.030911",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 800-277-1301",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f400-75ad-b8a3-4412839dc9cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f400-75ad-b8a3-4412839dc9cd",
        "storage_key": "property/6737460151191766/019e1e2c-f400-75ad-b8a3-4412839dc9cd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJp2Fauf-k-IgRU-CkjAnvPpc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_7c97d287-1829-4a29-8483-f9254fe52944",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Logan Elementary School",
      "poi_type": "Education",
      "poi_address": "815 Elmwood Ave, Columbia, SC 29201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-4836-7159-8957-bf0b14457b35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-4836-7159-8957-bf0b14457b35",
        "storage_key": "property/6737460151191766/019e1e2e-4836-7159-8957-bf0b14457b35.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://logan.richlandone.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10330481758440184203&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "logan-elementary-school",
      "poi_latitude": "34.0122728",
      "poi_longitude": "-81.0449993",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 803-343-2915",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f400-75ad-b8a3-4412839dc9cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f400-75ad-b8a3-4412839dc9cd",
        "storage_key": "property/6737460151191766/019e1e2c-f400-75ad-b8a3-4412839dc9cd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJz2DOV86k-IgRi9l6Em0-XY8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_78d139d8-d4ad-466e-9358-984503166da2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Hand Middle School",
      "poi_type": "Education",
      "poi_address": "2600 Wheat St, Columbia, SC 29205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-4a09-70a9-9367-28aa145a64ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-4a09-70a9-9367-28aa145a64ef",
        "storage_key": "property/6737460151191766/019e1e2e-4a09-70a9-9367-28aa145a64ef.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://hand.richlandone.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2010265713425668342&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hand-middle-school",
      "poi_latitude": "33.9950528",
      "poi_longitude": "-81.0065305",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 803-343-2947",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f400-75ad-b8a3-4412839dc9cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f400-75ad-b8a3-4412839dc9cd",
        "storage_key": "property/6737460151191766/019e1e2c-f400-75ad-b8a3-4412839dc9cd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJxxlmiba6-IgR9lji-APm5Rs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_224138b6-e2f9-4282-a951-35102ed2ebd9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Dreher High School",
      "poi_type": "Education",
      "poi_address": "3319 Millwood Ave, Columbia, SC 29205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-4966-735c-8a60-49c07173a95e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-4966-735c-8a60-49c07173a95e",
        "storage_key": "property/6737460151191766/019e1e2e-4966-735c-8a60-49c07173a95e.webp",
        "width": 1170,
        "height": 1032
      },
      "poi_business_url": "http://dreher.richlandone.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12559310036618277063&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dreher-high-school",
      "poi_latitude": "33.9990164",
      "poi_longitude": "-80.9938858",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 803-253-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f400-75ad-b8a3-4412839dc9cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f400-75ad-b8a3-4412839dc9cd",
        "storage_key": "property/6737460151191766/019e1e2c-f400-75ad-b8a3-4412839dc9cd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWUdrFt6v-IgRx3ChrO-hS64",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_2892dad8-d4a5-4601-b361-0d3450d7bf3c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Montessori School of Columbia",
      "poi_type": "Education",
      "poi_address": "411 S Maple St, Columbia, SC 29205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-4d46-7615-82d6-71f12f78e737.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-4d46-7615-82d6-71f12f78e737",
        "storage_key": "property/6737460151191766/019e1e2e-4d46-7615-82d6-71f12f78e737.webp",
        "width": 1129,
        "height": 633
      },
      "poi_business_url": "http://www.montessoricolumbia.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5434427454168307042&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "montessori-school-of-columbia",
      "poi_latitude": "33.9865161",
      "poi_longitude": "-81.0045148",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-783-8838",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bc-727d-80fb-44f8b25f3f87",
        "storage_key": "property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlQ16N7m6-IgRYhVVC_r2aks",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_c862795c-e13c-4f4a-b581-6ab1613af1d7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Shandon United Methodist Preschool",
      "poi_type": "Education",
      "poi_address": "3407 Devine St, Columbia, SC 29205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://sumpk.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=701932758907198141&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shandon-united-methodist-preschool",
      "poi_latitude": "33.9978799",
      "poi_longitude": "-80.99230030000001",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 803-256-1498",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f400-75ad-b8a3-4412839dc9cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f400-75ad-b8a3-4412839dc9cd",
        "storage_key": "property/6737460151191766/019e1e2c-f400-75ad-b8a3-4412839dc9cd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZbTOeau6-IgRvZrfDiDEvQk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_7da56206-1f24-4ebc-a5aa-6880d426f094",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Saint Joseph Catholic School",
      "poi_type": "Education",
      "poi_address": "3700 Devine St, Columbia, SC 29205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-4ecb-713c-81a4-ff65a7ceb7b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-4ecb-713c-81a4-ff65a7ceb7b4",
        "storage_key": "property/6737460151191766/019e1e2e-4ecb-713c-81a4-ff65a7ceb7b4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.stjosdevine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4168146316801391866&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-joseph-catholic-school",
      "poi_latitude": "33.9964884",
      "poi_longitude": "-80.9887499",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 803-254-6736",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f400-75ad-b8a3-4412839dc9cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f400-75ad-b8a3-4412839dc9cd",
        "storage_key": "property/6737460151191766/019e1e2c-f400-75ad-b8a3-4412839dc9cd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDa23Qqq6-IgR-rzMyP062Dk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_90fa521b-d0ea-489f-b21b-ca479999e25b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Richland One Middle College",
      "poi_type": "Education",
      "poi_address": "316 Beltline Blvd, Columbia, SC 29205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-4c74-74f0-898f-e10506b72c4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-4c74-74f0-898f-e10506b72c4b",
        "storage_key": "property/6737460151191766/019e1e2e-4c74-74f0-898f-e10506b72c4b.webp",
        "width": 370,
        "height": 425
      },
      "poi_business_url": "https://www.richlandone.org/romc",
      "poi_directions_map_url": "https://maps.google.com/?cid=6405837719917942979&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richland-one-middle-college",
      "poi_latitude": "33.9878463",
      "poi_longitude": "-80.98132269999999",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 803-738-7114",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f400-75ad-b8a3-4412839dc9cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f400-75ad-b8a3-4412839dc9cd",
        "storage_key": "property/6737460151191766/019e1e2c-f400-75ad-b8a3-4412839dc9cd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJiavvugiw-IgRw9iBeHcb5lg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_f112b7c5-1ee0-4cd3-acd5-8d545d8cd536",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Koger Center for the Arts",
      "poi_type": "Entertainment",
      "poi_address": "1051 Greene St, Columbia, SC 29201, USA",
      "poi_short_description": "Contemporary university-based theater hosting a variety of music, drama & dance performances.",
      "poi_long_description": "Contemporary university-based theater hosting a variety of music, drama & dance performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-4e90-77ff-95c4-9e9340af4d58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-4e90-77ff-95c4-9e9340af4d58",
        "storage_key": "property/6737460151191766/019e1e2e-4e90-77ff-95c4-9e9340af4d58.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kogercenterforthearts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12257849216363590786&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "koger-center-for-the-arts",
      "poi_latitude": "33.9954349",
      "poi_longitude": "-81.0341062",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 803-777-5112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bc-727d-80fb-44f8b25f3f87",
        "storage_key": "property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbXrGTCi7-IgRgvSm2-qgHKo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_9d0f8e36-601b-40bd-b7be-72669a4ead8f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Columbia Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "1515 Main St, Columbia, SC 29201, USA",
      "poi_short_description": "Paintings & sculptures spanning thousands of years, displayed in a contemporary building.",
      "poi_long_description": "Paintings & sculptures spanning thousands of years, displayed in a contemporary building.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-5641-7593-a4ed-82af5854690e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-5641-7593-a4ed-82af5854690e",
        "storage_key": "property/6737460151191766/019e1e2e-5641-7593-a4ed-82af5854690e.webp",
        "width": 1280,
        "height": 830
      },
      "poi_business_url": "https://www.columbiamuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17573773874273889936&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "columbia-museum-of-art",
      "poi_latitude": "34.0058172",
      "poi_longitude": "-81.0362938",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 803-799-2810",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f337-76cd-895a-c87905c4df59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f337-76cd-895a-c87905c4df59",
        "storage_key": "property/6737460151191766/019e1e2c-f337-76cd-895a-c87905c4df59.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJca7xktSk-IgRkK4ikzqW4vM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_e7f30fe0-c579-4374-87a3-bf69fa45bbb0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "South Carolina State Museum",
      "poi_type": "Entertainment",
      "poi_address": "301 Gervais St, Columbia, SC 29201, USA",
      "poi_short_description": "Exhibits on art, history, nature, science & technology, housed on 4 floors in a former textile mill.",
      "poi_long_description": "Exhibits on art, history, nature, science & technology, housed on 4 floors in a former textile mill.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-855f-73d0-ba96-f6fbed5d60f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-855f-73d0-ba96-f6fbed5d60f6",
        "storage_key": "property/6737460151191766/019e1e2c-855f-73d0-ba96-f6fbed5d60f6.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://scmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=928196305548677249&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-carolina-state-museum",
      "poi_latitude": "33.9990559",
      "poi_longitude": "-81.0480824",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 803-898-4921",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f337-76cd-895a-c87905c4df59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f337-76cd-895a-c87905c4df59",
        "storage_key": "property/6737460151191766/019e1e2c-f337-76cd-895a-c87905c4df59.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJB7F6NjG7-IgRgRAPQp-d4Qw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_b234779d-fa90-4327-9d13-2562fa4e103a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "EdVenture",
      "poi_type": "Entertainment",
      "poi_address": "211 Gervais St, Columbia, SC 29201, USA",
      "poi_short_description": "Over 350 hands-on exhibits that allow kids to explore human biology, nature, inventions & careers.",
      "poi_long_description": "Over 350 hands-on exhibits that allow kids to explore human biology, nature, inventions & careers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-5585-7659-8fa2-2481edd1a81d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-5585-7659-8fa2-2481edd1a81d",
        "storage_key": "property/6737460151191766/019e1e2e-5585-7659-8fa2-2481edd1a81d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://edventure.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5009014924889452888&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "edventure",
      "poi_latitude": "33.9971663",
      "poi_longitude": "-81.0481712",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 803-779-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f337-76cd-895a-c87905c4df59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f337-76cd-895a-c87905c4df59",
        "storage_key": "property/6737460151191766/019e1e2c-f337-76cd-895a-c87905c4df59.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJExeBHze7-IgRWHGqCImYg0U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_441b5b73-fcc2-41af-9ef0-d62c03a0b39e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Township Auditorium",
      "poi_type": "Entertainment",
      "poi_address": "1703 Taylor St, Columbia, SC 29201, USA",
      "poi_short_description": "Performance hall staging concerts and ballet, as well as other events, and welcoming wheelchairs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-5008-7229-bfe0-628a3ba2a169.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-5008-7229-bfe0-628a3ba2a169",
        "storage_key": "property/6737460151191766/019e1e2e-5008-7229-bfe0-628a3ba2a169.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://thetownship.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17024630509826557127&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "township-auditorium",
      "poi_latitude": "34.0095228",
      "poi_longitude": "-81.027622",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 803-576-2350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bc-727d-80fb-44f8b25f3f87",
        "storage_key": "property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl2a60zO7-IgRx0R9kj-jQ-w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "auditorium"
    },
    {
      "id": "custom_e195c4d2-8347-420b-8917-42ecddfdf067",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Nickelodeon Theater",
      "poi_type": "Entertainment",
      "poi_address": "1607 Main St, Columbia, SC 29201, USA",
      "poi_short_description": "Patrons sip beer & wine while watching independent & foreign films at this small nonprofit cinema.",
      "poi_long_description": "Patrons sip beer & wine while watching independent & foreign films at this small nonprofit cinema.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-5f30-72ce-a222-da9f9656286d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-5f30-72ce-a222-da9f9656286d",
        "storage_key": "property/6737460151191766/019e1e2e-5f30-72ce-a222-da9f9656286d.webp",
        "width": 1280,
        "height": 652
      },
      "poi_business_url": "https://nickelodeon.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10056715905331871030&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nickelodeon-theater",
      "poi_latitude": "34.0068542",
      "poi_longitude": "-81.0362645",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-254-8234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-85d2-76ce-8c11-8622b7079a1f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-85d2-76ce-8c11-8622b7079a1f",
        "storage_key": "property/6737460151191766/019e1e2e-85d2-76ce-8c11-8622b7079a1f.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-a_hyS27-IgRNr1TSNWhkIs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_5fce413c-d035-4180-8cc7-fca71da19eb8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Trustus Theatre",
      "poi_type": "Entertainment",
      "poi_address": "520 Lady St, Columbia, SC 29201, USA",
      "poi_short_description": "A professional company presenting new plays & musicals in a historic building, with an attached bar.",
      "poi_long_description": "A professional company presenting new plays & musicals in a historic building, with an attached bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-523e-7741-981e-c36c0b95a311.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-523e-7741-981e-c36c0b95a311",
        "storage_key": "property/6737460151191766/019e1e2e-523e-7741-981e-c36c0b95a311.webp",
        "width": 1280,
        "height": 786
      },
      "poi_business_url": "http://www.trustus.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18257923248747616119&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trustus-theatre",
      "poi_latitude": "33.9989929",
      "poi_longitude": "-81.04434959999999",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 803-254-9732",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bc-727d-80fb-44f8b25f3f87",
        "storage_key": "property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi13dKDK7-IgRd5fyyXUsYf0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_45b81768-7de8-4cb9-8b7c-e584e54fba08",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Columbia Marionette Theatre",
      "poi_type": "Entertainment",
      "poi_address": "401 Laurel St, Columbia, SC 29201, USA",
      "poi_short_description": "Theater where puppets perform on a roomy stage also has multiple themed rooms available for parties.",
      "poi_long_description": "Theater where puppets perform on a roomy stage also has multiple themed rooms available for parties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-53d0-716c-9901-1da343349cad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-53d0-716c-9901-1da343349cad",
        "storage_key": "property/6737460151191766/019e1e2e-53d0-716c-9901-1da343349cad.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cmtpuppet.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7700138818565838747&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "columbia-marionette-theatre",
      "poi_latitude": "34.0056968",
      "poi_longitude": "-81.0498724",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 803-252-7366",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bc-727d-80fb-44f8b25f3f87",
        "storage_key": "property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw071Osuk-IgRmxfQWXVj3Go",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_5f3837b8-ed5a-4800-bb0b-7f63536ed4d1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Prisma Health Richland Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "5 Richland Medical Park Dr, Columbia, SC 29203, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-9768-731c-9a63-feafa91fee89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-9768-731c-9a63-feafa91fee89",
        "storage_key": "property/6737460151191766/019e1e2c-9768-731c-9a63-feafa91fee89.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://prismahealth.org/locations/hospitals/richland-hospital?utm_source=gmb&utm_medium=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=12389614705206768817&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prisma-health-richland-hospital",
      "poi_latitude": "34.0278595",
      "poi_longitude": "-81.0333775",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 803-434-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f69f-76df-92f8-d6e4c4c3a2bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f69f-76df-92f8-d6e4c4c3a2bd",
        "storage_key": "property/6737460151191766/019e1e2c-f69f-76df-92f8-d6e4c4c3a2bd.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJNdA-P-Ck-IgRsTTOb-7A8Ks",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_f88b9200-9d5d-42b6-95e6-ec8e2ea4b9f9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Veritas Urgent Care - USC Downtown Columbia",
      "poi_type": "Health and Wellness",
      "poi_address": "126 S Assembly St, Columbia, SC 29201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-53e2-711b-bab7-a24374a9116d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-53e2-711b-bab7-a24374a9116d",
        "storage_key": "property/6737460151191766/019e1e2e-53e2-711b-bab7-a24374a9116d.webp",
        "width": 800,
        "height": 450
      },
      "poi_business_url": "http://www.veritasurgentcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17695792717212637774&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "veritas-urgent-care---usc-downtown-columbia",
      "poi_latitude": "33.9854459",
      "poi_longitude": "-81.0280631",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 803-766-1680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bc-727d-80fb-44f8b25f3f87",
        "storage_key": "property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3X043Ji7-IgRTlpnULgVlPU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_47a6687a-81dd-4c0a-93fc-cb9d809b5775",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Concentra Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "501 Huger St, Columbia, SC 29201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-536e-7343-b0f9-f61283c12498.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-536e-7343-b0f9-f61283c12498",
        "storage_key": "property/6737460151191766/019e1e2e-536e-7343-b0f9-f61283c12498.webp",
        "width": 640,
        "height": 368
      },
      "poi_business_url": "http://www.concentra.com/?utm_source=Yext&utm_medium=Organic&utm_campaign=Homepage%20Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=6993939395870748552&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "concentra-urgent-care",
      "poi_latitude": "33.9883967",
      "poi_longitude": "-81.0410965",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 803-799-3926",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bc-727d-80fb-44f8b25f3f87",
        "storage_key": "property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_cd3sEql-IgRiG98N9N2D2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_f969bf8e-25b1-4b64-8bdb-01acf0f421d4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "900 Assembly St, Columbia, SC 29201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-3a7c-767a-bae5-bf5ff9d741bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-3a7c-767a-bae5-bf5ff9d741bf",
        "storage_key": "property/6737460151191766/019e1e2e-3a7c-767a-bae5-bf5ff9d741bf.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/columbia-sc-pharmacies/900-assembly-st-columbia-sc-29201/storeid=830?WT.mc_id=LS_GOOGLE_RX_830",
      "poi_directions_map_url": "https://maps.google.com/?cid=9755858767899413804&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "33.9970084",
      "poi_longitude": "-81.0331281",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 803-212-7016",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-85ce-73dd-bc35-5fcd3baadb7b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-85ce-73dd-bc35-5fcd3baadb7b",
        "storage_key": "property/6737460151191766/019e1e2e-85ce-73dd-bc35-5fcd3baadb7b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw8gclCm7-IgRLE2GU9zFY4c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_c10cd877-0578-4d37-b45f-5e5337cc4730",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Hawthorne Taylor Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1520-A Taylor St, Columbia, SC 29201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-607b-7229-b073-0f9687b7e33e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-607b-7229-b073-0f9687b7e33e",
        "storage_key": "property/6737460151191766/019e1e2e-607b-7229-b073-0f9687b7e33e.webp",
        "width": 1280,
        "height": 941
      },
      "poi_business_url": "http://www.hawthornesc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6671332422233605779&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hawthorne-taylor-pharmacy",
      "poi_latitude": "34.0081537",
      "poi_longitude": "-81.0298475",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 803-256-3440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-85ce-73dd-bc35-5fcd3baadb7b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-85ce-73dd-bc35-5fcd3baadb7b",
        "storage_key": "property/6737460151191766/019e1e2e-85ce-73dd-bc35-5fcd3baadb7b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ87AvFyql-IgRk8bH5X1VlVw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_2e11b4e2-5fcd-4776-89c5-ff7cf04f6dde",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Downtown YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "1447 Hampton St, Columbia, SC 29201, USA",
      "poi_short_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_long_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-5919-738c-a949-879114f91ed6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-5919-738c-a949-879114f91ed6",
        "storage_key": "property/6737460151191766/019e1e2e-5919-738c-a949-879114f91ed6.webp",
        "width": 965,
        "height": 644
      },
      "poi_business_url": "http://www.columbiaymca.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15133246125517833456&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-ymca",
      "poi_latitude": "34.0068594",
      "poi_longitude": "-81.0309833",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 803-799-9187",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bc-727d-80fb-44f8b25f3f87",
        "storage_key": "property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJe8oQFNWk-IgR8AQM-isXBNI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_bc944a1a-5e9b-4d0d-85dd-5380c05fb7bb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Strom Thurmond Wellness and Fitness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1000 Blossom St, Columbia, SC 29201, USA",
      "poi_short_description": "State-of-the-art gym featuring a rock-climbing station as well as several swimming pools.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-8a73-7679-9a4a-0fc6665ead3b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-8a73-7679-9a4a-0fc6665ead3b",
        "storage_key": "property/6737460151191766/019e1e2c-8a73-7679-9a4a-0fc6665ead3b.webp",
        "width": 949,
        "height": 1280
      },
      "poi_business_url": "http://sc.edu/campusrec",
      "poi_directions_map_url": "https://maps.google.com/?cid=17788686174177275809&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "strom-thurmond-wellness-and-fitness-center",
      "poi_latitude": "33.9916066",
      "poi_longitude": "-81.031964",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 803-576-9376",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bc-727d-80fb-44f8b25f3f87",
        "storage_key": "property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk9Tc8Se7-IgRoS-9sNMb3vY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_742cf958-23a5-44f1-96c4-6b4db8a8d9cc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Pvolve Columbia",
      "poi_type": "Health and Wellness",
      "poi_address": "2140 Pickens St, Columbia, SC 29201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-5e16-74b9-811c-86a0eeab6a6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-5e16-74b9-811c-86a0eeab6a6d",
        "storage_key": "property/6737460151191766/019e1e2e-5e16-74b9-811c-86a0eeab6a6d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://studios.pvolve.com/columbia",
      "poi_directions_map_url": "https://maps.google.com/?cid=14092122012243832882&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pvolve-columbia",
      "poi_latitude": "34.0170375",
      "poi_longitude": "-81.0329994",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 803-263-8271",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bc-727d-80fb-44f8b25f3f87",
        "storage_key": "property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_5UvlF6l-IgRMrBBj05GkcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_06df4d36-58ae-47dc-8c7a-4d78ad9e9df3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "RISE Fitness + Wellness | Pilates Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "1727- A, Harden St, Columbia, SC 29204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-60bd-751a-ab16-968facfc79f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-60bd-751a-ab16-968facfc79f8",
        "storage_key": "property/6737460151191766/019e1e2e-60bd-751a-ab16-968facfc79f8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.risecolasc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10767859223483307867&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rise-fitness--wellness--pilates-studio",
      "poi_latitude": "34.0129159",
      "poi_longitude": "-81.02256179999999",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 803-881-1983",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f400-75ad-b8a3-4412839dc9cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f400-75ad-b8a3-4412839dc9cd",
        "storage_key": "property/6737460151191766/019e1e2c-f400-75ad-b8a3-4412839dc9cd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYyeVLIal-IgRW9cix-keb5U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_00c214fa-0ab3-4011-8d49-9a2b5bf2f6b7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Studio Fire",
      "poi_type": "Health and Wellness",
      "poi_address": "2917 Rosewood Dr, Columbia, SC 29205, USA",
      "poi_short_description": "Studio featuring vinyasa yoga, barre, and cardio classes, plus infrared heat.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-644b-72da-92e5-623c8a52df9e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-644b-72da-92e5-623c8a52df9e",
        "storage_key": "property/6737460151191766/019e1e2e-644b-72da-92e5-623c8a52df9e.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "http://www.studiofirefitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2952739551493514376&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "studio-fire",
      "poi_latitude": "33.9885072",
      "poi_longitude": "-81.001481",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 803-764-2010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f400-75ad-b8a3-4412839dc9cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f400-75ad-b8a3-4412839dc9cd",
        "storage_key": "property/6737460151191766/019e1e2c-f400-75ad-b8a3-4412839dc9cd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJE2uo8gy7-IgRiGQEUfo8-ig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_f9e8cac0-24c6-46ac-8b9e-4ff4a8b66c22",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Granby Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "100 Catawba Cir, Columbia, SC 29201, USA",
      "poi_short_description": "Natural retreat on the river with hiking, biking & horse trails, disc golf, fishing, camps & cabins.",
      "poi_long_description": "Natural retreat on the river with hiking, biking & horse trails, disc golf, fishing, camps & cabins.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-651e-749e-b575-7eb5f8074553.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-651e-749e-b575-7eb5f8074553",
        "storage_key": "property/6737460151191766/019e1e2e-651e-749e-b575-7eb5f8074553.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://parksandrec.columbiasc.gov/regionalparks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12366516078987582956&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "granby-park",
      "poi_latitude": "33.9838524",
      "poi_longitude": "-81.0442965",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6b9-776e-9fee-54fa7a610116.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6b9-776e-9fee-54fa7a610116",
        "storage_key": "property/6737460151191766/019e1e2c-f6b9-776e-9fee-54fa7a610116.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJbXCfRD27-IgR7B02bdqwnqs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ab4274a0-750f-49b3-a6cf-ae0cce8acc9e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Columbia Canal and Riverfront Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "312 Laurel St, Columbia, SC 29201, USA",
      "poi_short_description": "Old pump houses shed light on the canal works amid natural hiking & biking trails & picnic tables.",
      "poi_long_description": "Old pump houses shed light on the canal works amid natural hiking & biking trails & picnic tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-9baa-710b-be0d-221f341a186f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-9baa-710b-be0d-221f341a186f",
        "storage_key": "property/6737460151191766/019e1e2c-9baa-710b-be0d-221f341a186f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://parksandrec.columbiasc.gov/regionalparks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8911544469547747247&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "columbia-canal-and-riverfront-park",
      "poi_latitude": "34.0037859",
      "poi_longitude": "-81.05124239999999",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 803-545-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6b9-776e-9fee-54fa7a610116.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6b9-776e-9fee-54fa7a610116",
        "storage_key": "property/6737460151191766/019e1e2c-f6b9-776e-9fee-54fa7a610116.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ48T5nLCk-IgRr4d9y3oqrHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e04ce906-50c1-448e-98fb-9d526e9ec81d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Finlay Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "930 Laurel St, Columbia, SC 29201, USA",
      "poi_short_description": "An outdoor oasis with waterfalls, a lake, playgrounds, a pergola with swings & seasonal concessions.",
      "poi_long_description": "An outdoor oasis with waterfalls, a lake, playgrounds, a pergola with swings & seasonal concessions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-a699-7684-8447-6eee41ed7d67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-a699-7684-8447-6eee41ed7d67",
        "storage_key": "property/6737460151191766/019e1e2c-a699-7684-8447-6eee41ed7d67.webp",
        "width": 348,
        "height": 348
      },
      "poi_business_url": "https://discoversouthcarolina.com/products/1243",
      "poi_directions_map_url": "https://maps.google.com/?cid=218805609575239614&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "finlay-park",
      "poi_latitude": "34.0066031",
      "poi_longitude": "-81.04133039999999",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-733-8691",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6b9-776e-9fee-54fa7a610116.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6b9-776e-9fee-54fa7a610116",
        "storage_key": "property/6737460151191766/019e1e2c-f6b9-776e-9fee-54fa7a610116.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ4xl9NKk-IgRvk-Y6YpaCQM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_eb6c7507-c8f8-47d3-977c-e49f0e4e931a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Maxcy Gregg Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1806 Blossom St, Columbia, SC 29201, USA",
      "poi_short_description": "City green space with walking trails, a garden & an Olympic-sized, seasonal swimming pool.",
      "poi_long_description": "City green space with walking trails, a garden & an Olympic-sized, seasonal swimming pool.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-6964-764e-8cee-cc031632af48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-6964-764e-8cee-cc031632af48",
        "storage_key": "property/6737460151191766/019e1e2e-6964-764e-8cee-cc031632af48.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.columbiasc.net/parks-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=12571737489455133840&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maxcy-gregg-park",
      "poi_latitude": "33.9970172",
      "poi_longitude": "-81.0208119",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 803-545-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6b9-776e-9fee-54fa7a610116.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6b9-776e-9fee-54fa7a610116",
        "storage_key": "property/6737460151191766/019e1e2c-f6b9-776e-9fee-54fa7a610116.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJu1C27dG6-IgRkDRvhKPId64",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b5a8fe46-1d21-4213-a5c2-ef8e4acad0f6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "The Horseshoe",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Sumter St, Columbia, SC 29208, USA",
      "poi_short_description": "Historic college campus park with a peaceful atmosphere and scenic lawns.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-6db4-7619-815e-498fe2556618.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-6db4-7619-815e-498fe2556618",
        "storage_key": "property/6737460151191766/019e1e2e-6db4-7619-815e-498fe2556618.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18332716853178022546&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-horseshoe",
      "poi_latitude": "33.9981588",
      "poi_longitude": "-81.02888279999999",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6b9-776e-9fee-54fa7a610116.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6b9-776e-9fee-54fa7a610116",
        "storage_key": "property/6737460151191766/019e1e2c-f6b9-776e-9fee-54fa7a610116.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJUZezdW6-IgRkjp-2djkav4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f7fdbd2f-1778-4337-978a-b3b9d9ebb319",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Hampton-Preston Mansion and Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1615 Blanding St, Columbia, SC 29201, USA",
      "poi_short_description": "1818 family residence & onetime governor's mansion open for tours of interior & surrounding gardens.",
      "poi_long_description": "1818 family residence & onetime governor's mansion open for tours of interior & surrounding gardens.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-6ae5-7238-9c39-987fa6818df2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-6ae5-7238-9c39-987fa6818df2",
        "storage_key": "property/6737460151191766/019e1e2e-6ae5-7238-9c39-987fa6818df2.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "http://www.historiccolumbia.org/hampton-preston-mansion-and-gardens",
      "poi_directions_map_url": "https://maps.google.com/?cid=7297446809818697081&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hampton-preston-mansion-and-gardens",
      "poi_latitude": "34.0105056",
      "poi_longitude": "-81.0294437",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 803-252-7742",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f337-76cd-895a-c87905c4df59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f337-76cd-895a-c87905c4df59",
        "storage_key": "property/6737460151191766/019e1e2c-f337-76cd-895a-c87905c4df59.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ49nnlyml-IgReQ2NwjW9RWU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_f389665a-4847-4532-9e7a-f8ee7220f50f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Saluda Riverwalk",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "650 Candi Ln, Columbia, SC 29210, USA",
      "poi_short_description": "Popular public park featuring a 7-mile trail for walking, biking and kayaking, plus picnic areas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-9fa4-7696-8998-41d786485aa0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-9fa4-7696-8998-41d786485aa0",
        "storage_key": "property/6737460151191766/019e1e2c-9fa4-7696-8998-41d786485aa0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://parksandrec.columbiasc.gov/regionalparks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10143068239537940972&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saluda-riverwalk",
      "poi_latitude": "34.0135766",
      "poi_longitude": "-81.082009",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 803-397-6556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6b9-776e-9fee-54fa7a610116.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6b9-776e-9fee-54fa7a610116",
        "storage_key": "property/6737460151191766/019e1e2c-f6b9-776e-9fee-54fa7a610116.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJM0EhNVqj-IgR7Kk01tJqw4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6c04565f-54d0-427a-8209-3423fb8849d8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "West Columbia Riverwalk Park and Amphitheater",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "109 Alexander Rd, West Columbia, SC 29169, USA",
      "poi_short_description": "This park on the Congaree River features an amphitheater & connects with the Three Rivers Greenway.",
      "poi_long_description": "This park on the Congaree River features an amphitheater & connects with the Three Rivers Greenway.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-a456-739b-9e4f-d04b4ccf9b77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-a456-739b-9e4f-d04b4ccf9b77",
        "storage_key": "property/6737460151191766/019e1e2c-a456-739b-9e4f-d04b4ccf9b77.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://westcolumbiasc.gov/recreation/riverwalk-park-amphitheater/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13424275961736358566&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-columbia-riverwalk-park-and-amphitheater",
      "poi_latitude": "33.9947003",
      "poi_longitude": "-81.0529644",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 803-791-1880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6b9-776e-9fee-54fa7a610116.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6b9-776e-9fee-54fa7a610116",
        "storage_key": "property/6737460151191766/019e1e2c-f6b9-776e-9fee-54fa7a610116.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKcFG-ze7-IgRpmocwtybTLo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_f2c5015e-af72-4a53-bb94-b07707c6cf95",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Olympia Mill at The Mills",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "600 Heyward St, Columbia, SC 29201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-6dc6-7261-ac51-584aa7596c0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-6dc6-7261-ac51-584aa7596c0e",
        "storage_key": "property/6737460151191766/019e1e2e-6dc6-7261-ac51-584aa7596c0e.webp",
        "width": 1024,
        "height": 679
      },
      "poi_business_url": "http://millsliving.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8229058797627986425&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olympia-mill-at-the-mills",
      "poi_latitude": "33.9827894",
      "poi_longitude": "-81.0363038",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 803-667-3705",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bc-727d-80fb-44f8b25f3f87",
        "storage_key": "property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ13w3Fwu7-IgR-VFrhGB9M3I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "apartment_complex"
    },
    {
      "id": "custom_db2b8d87-9340-461d-9093-9b90f9c76874",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Riverbanks Zoo & Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "500 Wildlife Pkwy, Columbia, SC 29210, USA",
      "poi_short_description": "Zoo with African & Australian animals, reptile galleries, a bird house, a farm & botanical gardens.",
      "poi_long_description": "Zoo with African & Australian animals, reptile galleries, a bird house, a farm & botanical gardens.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-81f1-7759-a290-a5a025f84f1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-81f1-7759-a290-a5a025f84f1e",
        "storage_key": "property/6737460151191766/019e1e2c-81f1-7759-a290-a5a025f84f1e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.riverbanks.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5878382912266439608&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverbanks-zoo--garden",
      "poi_latitude": "34.0086627",
      "poi_longitude": "-81.0733959",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 803-779-8717",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bc-727d-80fb-44f8b25f3f87",
        "storage_key": "property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJryFyj1Wj-IgRuAteGx02lFE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_dc7668d2-46e8-479f-a497-aa9ed0300ae6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "COMET Central",
      "poi_type": "Transportation & Transit",
      "poi_address": "1727 Sumter St, Columbia, SC 29201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-70d6-70f6-a407-b94632b9171a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-70d6-70f6-a407-b94632b9171a",
        "storage_key": "property/6737460151191766/019e1e2e-70d6-70f6-a407-b94632b9171a.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "http://catchthecometsc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4433816841727021501&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "comet-central",
      "poi_latitude": "34.0094873",
      "poi_longitude": "-81.03573279999999",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-255-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bc-727d-80fb-44f8b25f3f87",
        "storage_key": "property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJua8MJ4al-IgRvZFIGu0UiD0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_af194a52-b4db-47c9-9dec-941125488215",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "The COMET",
      "poi_type": "Transportation & Transit",
      "poi_address": "3613 Lucius Rd, Columbia, SC 29201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-73e5-71fe-94fe-92faccddafad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-73e5-71fe-94fe-92faccddafad",
        "storage_key": "property/6737460151191766/019e1e2e-73e5-71fe-94fe-92faccddafad.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://catchthecomet.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15608626348532324891&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-comet",
      "poi_latitude": "34.024335",
      "poi_longitude": "-81.061358",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 803-255-7085",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bc-727d-80fb-44f8b25f3f87",
        "storage_key": "property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC18DWryk-IgRG1oSSPf6nNg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "custom_a109661f-e24a-4d09-b7d6-a5437df34b29",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Columbia, S.C.",
      "poi_type": "Transportation & Transit",
      "poi_address": "850 Pulaski St, Columbia, SC 29201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-beba-70b0-bcaa-cd8baaa5ce47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-beba-70b0-bcaa-cd8baaa5ce47",
        "storage_key": "property/6737460151191766/019e1e2c-beba-70b0-bcaa-cd8baaa5ce47.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=CLB",
      "poi_directions_map_url": "https://maps.google.com/?cid=12080425933444662154&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "columbia-sc",
      "poi_latitude": "33.9942692",
      "poi_longitude": "-81.0402857",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-fcdd-74d0-aadc-91e552945a7f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-fcdd-74d0-aadc-91e552945a7f",
        "storage_key": "property/6737460151191766/019e1e2c-fcdd-74d0-aadc-91e552945a7f.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJEe4B7i-7-IgRisNismFLpqc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_da1708f8-ae2d-4c45-a4cc-82b12a714b8c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Columbia Metropolitan Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "3250 Airport Blvd, West Columbia, SC 29170, USA",
      "poi_short_description": "Airport serving the Southeast & offering a range of commercial & charter flights.",
      "poi_long_description": "Airport serving the Southeast & offering a range of commercial & charter flights.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-bf2c-73ae-abe9-9e33366a29f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-bf2c-73ae-abe9-9e33366a29f7",
        "storage_key": "property/6737460151191766/019e1e2c-bf2c-73ae-abe9-9e33366a29f7.webp",
        "width": 1215,
        "height": 1280
      },
      "poi_business_url": "http://flycae.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7649969984303653536&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "columbia-metropolitan-airport",
      "poi_latitude": "33.941917",
      "poi_longitude": "-81.1220015",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 803-822-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6b4-776a-a427-a4573d344f4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6b4-776a-a427-a4573d344f4d",
        "storage_key": "property/6737460151191766/019e1e2c-f6b4-776a-a427-a4573d344f4d.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-RR4iMu9-IgRoOLRYCsnKmo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_8bacba06-228e-408b-ae4a-42228a675d94",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "South Carolina State Fair",
      "poi_type": "Transportation & Transit",
      "poi_address": "1200 Rosewood Dr, Columbia, SC 29201, USA",
      "poi_short_description": "Popular state fair featuring rides, agricultural exhibits and fried fare.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-7658-7009-9961-8c18e1fc1c93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-7658-7009-9961-8c18e1fc1c93",
        "storage_key": "property/6737460151191766/019e1e2e-7658-7009-9961-8c18e1fc1c93.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.scstatefair.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1161591201273386685&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-carolina-state-fair",
      "poi_latitude": "33.9779441",
      "poi_longitude": "-81.02359",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 803-799-3387",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bc-727d-80fb-44f8b25f3f87",
        "storage_key": "property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSfax1ee6-IgRvZYeDgvNHhA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_8c76d9af-488b-4545-8d33-6619d935f71f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Colonial Life Arena",
      "poi_type": "Entertainment",
      "poi_address": "801 Lincoln St, Columbia, SC 29201, USA",
      "poi_short_description": "Indoor arena hosting University of South Carolina basketball games & shows by iconic music acts.",
      "poi_long_description": "Indoor arena hosting University of South Carolina basketball games & shows by iconic music acts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-7fff-730f-b36b-b39899011c83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2c-7fff-730f-b36b-b39899011c83",
        "storage_key": "property/6737460151191766/019e1e2c-7fff-730f-b36b-b39899011c83.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.coloniallifearena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3456536445372366308&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colonial-life-arena",
      "poi_latitude": "33.9948495",
      "poi_longitude": "-81.0371971",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 803-576-9053",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bc-727d-80fb-44f8b25f3f87",
        "storage_key": "property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4e2prSi7-IgR5H2cY5UV-C8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_85e61bb8-5b17-4eae-9c45-132ccbd5f27f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Carolina Coliseum",
      "poi_type": "Transportation & Transit",
      "poi_address": "701 Assembly St, Columbia, SC 29201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-7977-7497-aa83-44aedfe24813.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-7977-7497-aa83-44aedfe24813",
        "storage_key": "property/6737460151191766/019e1e2e-7977-7497-aa83-44aedfe24813.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6070042431434720106&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carolina-coliseum",
      "poi_latitude": "33.9936687",
      "poi_longitude": "-81.03304840000001",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 803-777-5113",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f400-75ad-b8a3-4412839dc9cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f400-75ad-b8a3-4412839dc9cd",
        "storage_key": "property/6737460151191766/019e1e2c-f400-75ad-b8a3-4412839dc9cd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJuRkEPii7-IgRagM3UW4fPVQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "academic_department"
    },
    {
      "id": "custom_acf13964-9c26-46af-9f6f-d302e55b602f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "USC School of Music",
      "poi_type": "Transportation & Transit",
      "poi_address": "813 Assembly St, Columbia, SC 29208, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-71fd-717c-a84a-70fda0c2e0dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-71fd-717c-a84a-70fda0c2e0dc",
        "storage_key": "property/6737460151191766/019e1e2e-71fd-717c-a84a-70fda0c2e0dc.webp",
        "width": 600,
        "height": 400
      },
      "poi_business_url": "http://www.sc.edu/study/colleges_schools/music/index.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=1824042677233109019&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "usc-school-of-music",
      "poi_latitude": "33.9958607",
      "poi_longitude": "-81.0346273",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 803-777-4280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f400-75ad-b8a3-4412839dc9cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f400-75ad-b8a3-4412839dc9cd",
        "storage_key": "property/6737460151191766/019e1e2c-f400-75ad-b8a3-4412839dc9cd.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsQ-gtCm7-IgRG8ihlyZNUBk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "academic_department"
    },
    {
      "id": "custom_5f5cc544-140e-4793-ac88-e8df278bd1af",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Lincoln St. Parking Deck",
      "poi_type": "Transportation & Transit",
      "poi_address": "820 Washington St, Columbia, SC 29201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-73a8-772b-94b4-b64748f66515.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-73a8-772b-94b4-b64748f66515",
        "storage_key": "property/6737460151191766/019e1e2e-73a8-772b-94b4-b64748f66515.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.columbiasc.net/parking",
      "poi_directions_map_url": "https://maps.google.com/?cid=4731081908761197582&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lincoln-st-parking-deck",
      "poi_latitude": "34.0021065",
      "poi_longitude": "-81.040127",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 803-545-4015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-85de-73a8-a22d-ee9cc692afca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-85de-73a8-a22d-ee9cc692afca",
        "storage_key": "property/6737460151191766/019e1e2e-85de-73a8-a22d-ee9cc692afca.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJP_4ABC27-IgRDvz8_u0tqEE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_garage"
    },
    {
      "id": "custom_d2af53dd-5182-41c3-ae5c-b254dfb46ca3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Visitor Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1501 Pendleton St, Columbia, SC 29208, USA",
      "poi_short_description": "Free-admission campus featuring tree-shaded grounds and a football stadium for the school of the same name.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-74be-723b-a7a1-a179bb92668a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-74be-723b-a7a1-a179bb92668a",
        "storage_key": "property/6737460151191766/019e1e2e-74be-723b-a7a1-a179bb92668a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://sc.edu/visit/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9791714906684796466&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "visitor-center",
      "poi_latitude": "33.9987556",
      "poi_longitude": "-81.0269833",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 800-922-9755",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bc-727d-80fb-44f8b25f3f87",
        "storage_key": "property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW0TaPdS6-IgRMi7YMtQo44c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "visitor_center"
    },
    {
      "id": "custom_32469ef7-d567-4f2e-900f-e2c46114f098",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "S.C. Department of Health and Environmental Control: Administrative Offices",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2100 Bull St, Columbia, SC 29201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://dph.sc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15645336916529908183&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sc-department-of-health-and-environmental-control-administrative-offices",
      "poi_latitude": "34.0142561",
      "poi_longitude": "-81.0324833",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 803-898-3432",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-fcf8-7104-8ea6-3df5d589c1ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-fcf8-7104-8ea6-3df5d589c1ee",
        "storage_key": "property/6737460151191766/019e1e2c-fcf8-7104-8ea6-3df5d589c1ee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY2z489ek-IgR1wkSdQhnH9k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_281f1b1c-9c1d-474b-b553-70bdbb3faea6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "South Carolina State House",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1100 Gervais St, Columbia, SC 29208, USA",
      "poi_short_description": "Grand edifice for the state's House, Senate & Governor's office, with free tours & leafy grounds.",
      "poi_long_description": "Grand edifice for the state's House, Senate & Governor's office, with free tours & leafy grounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-796d-75fa-a0b8-60e12f936d73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-796d-75fa-a0b8-60e12f936d73",
        "storage_key": "property/6737460151191766/019e1e2e-796d-75fa-a0b8-60e12f936d73.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.scstatehouse.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10022710692616832768&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-carolina-state-house",
      "poi_latitude": "34.0000786",
      "poi_longitude": "-81.0329971",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 803-734-5049",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-fcf8-7104-8ea6-3df5d589c1ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-fcf8-7104-8ea6-3df5d589c1ee",
        "storage_key": "property/6737460151191766/019e1e2c-fcf8-7104-8ea6-3df5d589c1ee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz4zptSu7-IgRAIfvt0XSF4s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_63e50c83-0621-412e-af7d-7430a1ef58d8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "AgFirst Farm Credit Bank",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Bank of America Plaza, 1901 Main St, Columbia, SC 29201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-7bd9-765c-930f-492dee05d3b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-7bd9-765c-930f-492dee05d3b8",
        "storage_key": "property/6737460151191766/019e1e2e-7bd9-765c-930f-492dee05d3b8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.agfirst.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12086744904187802695&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "agfirst-farm-credit-bank",
      "poi_latitude": "34.01077",
      "poi_longitude": "-81.0381366",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 800-845-1745",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bc-727d-80fb-44f8b25f3f87",
        "storage_key": "property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMZAka9Gk-IgRR3TguHO-vKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "finance"
    },
    {
      "id": "custom_73571bc2-46f9-4e68-8e53-094dee55f0a7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Palmetto GBA LLC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "17 Technology Cir, Columbia, SC 29203, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.palmettogba.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7789964078363413167&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "palmetto-gba-llc",
      "poi_latitude": "34.0959722",
      "poi_longitude": "-80.9662719",
      "poi_miles_from_property": "10.4",
      "poi_walking_minutes": "3 hours 53 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 803-735-1034",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bc-727d-80fb-44f8b25f3f87",
        "storage_key": "property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP-9NJbio-IgRr4rnZw6DG2w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "insurance_agency"
    },
    {
      "id": "custom_f5c94f03-57d3-4bb4-a943-6d7e542dc317",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Colonial Life",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1200 Colonial Life Blvd W, Columbia, SC 29210, USA",
      "poi_short_description": "Insurance agency in a chain providing life insurance.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-795b-7268-99d9-41820fae7ff4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-795b-7268-99d9-41820fae7ff4",
        "storage_key": "property/6737460151191766/019e1e2e-795b-7268-99d9-41820fae7ff4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.coloniallife.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9637347563222655822&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colonial-life",
      "poi_latitude": "34.0254859",
      "poi_longitude": "-81.0919754",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-325-4368",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bc-727d-80fb-44f8b25f3f87",
        "storage_key": "property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzQQyAESj-IgRTuPcQoy8voU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "insurance_agency"
    },
    {
      "id": "custom_929d93a3-9f4f-4982-b541-598b0ba12b1c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Nelson Mullins Riley & Scarborough LLP",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1320 Main St 17th floor, Columbia, SC 29201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-7e6f-74ce-bd6e-e68eef9a74de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-7e6f-74ce-bd6e-e68eef9a74de",
        "storage_key": "property/6737460151191766/019e1e2e-7e6f-74ce-bd6e-e68eef9a74de.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.nelsonmullins.com/locations/columbia_sc#main?utm_source=GMB&utm_medium=Yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=6356158887251439527&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nelson-mullins-riley--scarborough-llp",
      "poi_latitude": "34.0033522",
      "poi_longitude": "-81.0339182",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 803-799-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bc-727d-80fb-44f8b25f3f87",
        "storage_key": "property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwxea2Fil-IgRp2-Q4tScNVg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "custom_613e4f74-1a85-4f4b-85a2-427f42077992",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Richland County Administrative",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2020 Hampton St, Columbia, SC 29204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.richlandcountysc.gov/Government/Departments/Executive/Administration",
      "poi_directions_map_url": "https://maps.google.com/?cid=15388324085270599653&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richland-county-administrative",
      "poi_latitude": "34.0085905",
      "poi_longitude": "-81.0209587",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 803-576-2050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-fcf8-7104-8ea6-3df5d589c1ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-fcf8-7104-8ea6-3df5d589c1ee",
        "storage_key": "property/6737460151191766/019e1e2c-fcf8-7104-8ea6-3df5d589c1ee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTfl74i2l-IgR5VckhzlPjtU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_fae651a7-2928-42af-a280-a0c1d0f56c00",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "William Jennings Bryan Dorn Veterans Affairs Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6439 Garners Ferry Rd, Columbia, SC 29209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-7e8d-7785-8e41-01c7f1346bef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e2e-7e8d-7785-8e41-01c7f1346bef",
        "storage_key": "property/6737460151191766/019e1e2e-7e8d-7785-8e41-01c7f1346bef.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.columbiasc.va.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15102862645337255401&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "william-jennings-bryan-dorn-veterans-affairs-medical-center",
      "poi_latitude": "33.9754103",
      "poi_longitude": "-80.95970340000001",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 803-776-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-fcf8-7104-8ea6-3df5d589c1ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-fcf8-7104-8ea6-3df5d589c1ee",
        "storage_key": "property/6737460151191766/019e1e2c-fcf8-7104-8ea6-3df5d589c1ee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuajvej-w-IgR6e3Xuo4lmNE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_190ddfe2-e9fb-42a9-aea6-763f58859cf5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Miss Cocky",
      "poi_type": "Shopping & Retail",
      "poi_address": "1450 Main St, Columbia, SC 29201, USA",
      "poi_short_description": "Festive shop specializing in garnet & black clothing with the South Carolina Gamecocks logo.",
      "poi_long_description": "Festive shop specializing in garnet & black clothing with the South Carolina Gamecocks logo.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019ea911-318c-71ae-8ff4-3ca0c6799d0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea911-318c-71ae-8ff4-3ca0c6799d0a",
        "storage_key": "property/6737460151191766/019ea911-318c-71ae-8ff4-3ca0c6799d0a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.misscocky.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14241539969073898004&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "miss-cocky",
      "poi_latitude": "34.0051487",
      "poi_longitude": "-81.03507239999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-748-4771",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f321-7739-aa86-227d3db205c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f321-7739-aa86-227d3db205c7",
        "storage_key": "property/6737460151191766/019e1e2c-f321-7739-aa86-227d3db205c7.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJGaEG5CW7-IgRFGItnyUdpMU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_1242fcf5-a478-4fb7-a353-f43ce81de519",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Local Boy Outfitters",
      "poi_type": "Shopping & Retail",
      "poi_address": "419 Huger St, Columbia, SC 29201, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this clothing store offers a wide variety of apparel, including hoodies, polo shirts, and hats, for the whole family and even pets. They also highlight the great customer service, fast shipping, and easy exchange process.\n\nOther reviews mention the quality can be low.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019ea911-38f9-74ad-bff5-f189276130b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea911-38f9-74ad-bff5-f189276130b4",
        "storage_key": "property/6737460151191766/019ea911-38f9-74ad-bff5-f189276130b4.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://localboyoutfitters.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17436100817770724579&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "local-boy-outfitters",
      "poi_latitude": "33.986964",
      "poi_longitude": "-81.040599",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-726-0144",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f321-7739-aa86-227d3db205c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f321-7739-aa86-227d3db205c7",
        "storage_key": "property/6737460151191766/019e1e2c-f321-7739-aa86-227d3db205c7.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJCcEfaCO7-IgR4zwfN1B5-fE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_88e5f249-d081-41b8-a2fc-83fd29f7d678",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Urban Outfitters",
      "poi_type": "Shopping & Retail",
      "poi_address": "912 Gervais St, Columbia, SC 29201, USA",
      "poi_short_description": "Chain with a hipster vibe known for on-trend fashions, accessories & quirky home-decor items.",
      "poi_long_description": "Chain with a hipster vibe known for on-trend fashions, accessories & quirky home-decor items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019ea911-312a-75aa-a5a1-67e17cdc3b6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea911-312a-75aa-a5a1-67e17cdc3b6c",
        "storage_key": "property/6737460151191766/019ea911-312a-75aa-a5a1-67e17cdc3b6c.webp",
        "width": 512,
        "height": 289
      },
      "poi_business_url": "https://www.urbanoutfitters.com/stores/urban-outfitters-columbia?utm_medium=organic&utm_source=google&utm_campaign=local&utm_content=1005",
      "poi_directions_map_url": "https://maps.google.com/?cid=4215435290063897128&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "urban-outfitters",
      "poi_latitude": "33.999785",
      "poi_longitude": "-81.037892",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-254-5381",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f321-7739-aa86-227d3db205c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f321-7739-aa86-227d3db205c7",
        "storage_key": "property/6737460151191766/019e1e2c-f321-7739-aa86-227d3db205c7.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ4dqsFCy7-IgRKILn3Q88gDo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_5f0d9136-0b9c-479b-8449-8f93ba6f3cc0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Barefoot Campus Outfitter",
      "poi_type": "Shopping & Retail",
      "poi_address": "700 Lincoln St STE 100, Columbia, SC 29201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019ea911-3372-746c-8b47-554fa1eb8cce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea911-3372-746c-8b47-554fa1eb8cce",
        "storage_key": "property/6737460151191766/019ea911-3372-746c-8b47-554fa1eb8cce.webp",
        "width": 1280,
        "height": 989
      },
      "poi_business_url": "https://www.barefootcampusoutfitter.com/collections/south-carolina",
      "poi_directions_map_url": "https://maps.google.com/?cid=3117083317139282223&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "barefoot-campus-outfitter",
      "poi_latitude": "33.9935105",
      "poi_longitude": "-81.0354275",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-939-6999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f321-7739-aa86-227d3db205c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f321-7739-aa86-227d3db205c7",
        "storage_key": "property/6737460151191766/019e1e2c-f321-7739-aa86-227d3db205c7.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ481ynyi7-IgRLxliDcMaQis",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_e217cdf9-6657-4f82-abf2-6b06379d9b36",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Thirsty Fellow Pizzeria and Pub",
      "poi_type": "Restaurants",
      "poi_address": "621 Gadsden St, Columbia, SC 29201, USA",
      "poi_short_description": "Relaxed setting for stone-fired pizzas, upscale pub food, beer & wine from lunch till late-night.",
      "poi_long_description": "People say this pizza restaurant serves delicious pizza, sandwiches, and cocktails. They also highlight the reasonable prices, friendly staff, and great atmosphere for watching sports.\n\nSome reviews mention there can be a long wait.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019ea911-324b-71cb-9a20-41df787343b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea911-324b-71cb-9a20-41df787343b0",
        "storage_key": "property/6737460151191766/019ea911-324b-71cb-9a20-41df787343b0.webp",
        "width": 1280,
        "height": 688
      },
      "poi_business_url": "http://thirstyfellow.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5053946764731586152&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "thirsty-fellow-pizzeria-and-pub",
      "poi_latitude": "33.9920527",
      "poi_longitude": "-81.037154",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-799-1311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bb-70de-82c1-f99e154c6890.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bb-70de-82c1-f99e154c6890",
        "storage_key": "property/6737460151191766/019e1e2c-f6bb-70de-82c1-f99e154c6890.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGaEG5CW7-IgRaJaPOc45I0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_1bb365ac-acae-4efa-a130-908211feed69",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Cafe Strudel West Columbia",
      "poi_type": "Restaurants",
      "poi_address": "300 State St, West Columbia, SC 29169, USA",
      "poi_short_description": "Buzzy cafe & espresso bar known for their hangover hash browns serves all-day eats plus beer & wine.",
      "poi_long_description": "Diners say this American restaurant serves up delicious hangover hash browns, breakfast sandwiches, and grits. They also highlight the friendly and attentive service, as well as the eclectic and artsy atmosphere.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019ea911-37d4-7580-9e0f-4350b960ba95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea911-37d4-7580-9e0f-4350b960ba95",
        "storage_key": "property/6737460151191766/019ea911-37d4-7580-9e0f-4350b960ba95.webp",
        "width": 1280,
        "height": 863
      },
      "poi_business_url": "http://cafestrudel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17737468480844013887&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cafe-strudel-west-columbia",
      "poi_latitude": "33.9919359",
      "poi_longitude": "-81.0561778",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-794-6634",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bb-70de-82c1-f99e154c6890.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bb-70de-82c1-f99e154c6890",
        "storage_key": "property/6737460151191766/019e1e2c-f6bb-70de-82c1-f99e154c6890.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJd7ph00e7-IgRPyFlL5slKPY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_962d51fa-a26a-4fc8-a461-66ec74b644cb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Tsunami Sushi Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "700 Gervais St A, Columbia, SC 29201, USA",
      "poi_short_description": "Local chain serving a menu of sushi & Pan-Asian entrees in a contemporary, stylish space.",
      "poi_long_description": "Diners say this sushi restaurant offers delicious sushi rolls, including the Spicy California Roll, Montana Roll, and Salad Roll, and they praise the great happy hour deals. They also highlight the attentive and helpful service, and the cozy and romantic atmosphere.\n\nSome reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019ea911-319d-7617-b171-376c6ad2d658.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea911-319d-7617-b171-376c6ad2d658",
        "storage_key": "property/6737460151191766/019ea911-319d-7617-b171-376c6ad2d658.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://sites.google.com/view/tsunami-vista/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=4267108456557139082&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tsunami-sushi-restaurant",
      "poi_latitude": "33.9983474",
      "poi_longitude": "-81.04039879999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-312-9911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bb-70de-82c1-f99e154c6890.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bb-70de-82c1-f99e154c6890",
        "storage_key": "property/6737460151191766/019e1e2c-f6bb-70de-82c1-f99e154c6890.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzd4veC67-IgRilQne4jQNzs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_7ca50a45-5dca-42dd-92bb-73e84a49cd5e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Grill Marks - COLA",
      "poi_type": "Restaurants",
      "poi_address": "711 Gervais St, Columbia, SC 29201, USA",
      "poi_short_description": "Casual burger restaurant offering milkshakes, burgers, fries and hot wings, plus a full bar.",
      "poi_long_description": "People say this hamburger restaurant serves delicious burgers, including smash burgers, and offers a variety of sauces, such as the orange cinnamon dipping sauce for sweet potato fries. They also highlight the friendly staff, the pet-friendly patio, and the great milkshakes and drinks, such as Bloody Marys.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019ea911-376d-7752-a695-3e2c43ac361b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea911-376d-7752-a695-3e2c43ac361b",
        "storage_key": "property/6737460151191766/019ea911-376d-7752-a695-3e2c43ac361b.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.grillmarks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14176511024514284832&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "grill-marks---cola",
      "poi_latitude": "33.9994058",
      "poi_longitude": "-81.04073919999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-661-8932",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bb-70de-82c1-f99e154c6890.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bb-70de-82c1-f99e154c6890",
        "storage_key": "property/6737460151191766/019e1e2c-f6bb-70de-82c1-f99e154c6890.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJed9swy27-IgRID2VmqoVvcQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_3c54a7e8-01f4-415c-91e3-1993fc9a657e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "California Dreaming",
      "poi_type": "Restaurants",
      "poi_address": "401 Main St, Columbia, SC 29201, USA",
      "poi_short_description": "Relaxed restaurant & bar chain serving steak & seafood, plus signature nachos, sandwiches & pasta.",
      "poi_long_description": "People say this American restaurant serves delicious croissants, salads, and chicken tenders. They also highlight the unique atmosphere in a historic train station, and the attentive and friendly service.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019ea911-30fd-738c-bad7-6521ea7c7cf7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea911-30fd-738c-bad7-6521ea7c7cf7",
        "storage_key": "property/6737460151191766/019ea911-30fd-738c-bad7-6521ea7c7cf7.webp",
        "width": 810,
        "height": 540
      },
      "poi_business_url": "https://californiadreaming.rest/location/Columbia-SC/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17564601323012512629&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "california-dreaming",
      "poi_latitude": "33.9905565",
      "poi_longitude": "-81.0294437",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-254-6767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bb-70de-82c1-f99e154c6890.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bb-70de-82c1-f99e154c6890",
        "storage_key": "property/6737460151191766/019e1e2c-f6bb-70de-82c1-f99e154c6890.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_RKcQdi6-IgRdVuEj9f_wfM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_129cb3ac-98f6-4e6a-ad4c-6697ae541d45",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Bowlero",
      "poi_type": "Entertainment",
      "poi_address": "900 Axtell Dr. Cayce, SC 29033",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_366a12a3-74ae-436e-8f7d-4a1ba9d7038c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Bang Back Pinball Lounge",
      "poi_type": "Entertainment",
      "poi_address": "741 Saluda Ave, Columbia, SC 29205, USA",
      "poi_short_description": "Offering a large selection of craft beer, cocktails, and appetizers, this casual hangout features 24 pinball machines.",
      "poi_long_description": "People say this restaurant offers a wide selection of drinks and fun pinball games. They highlight the cheap drinks and fun atmosphere. They also like the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019ea914-dd74-708d-afee-1c0ff8f9b4eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea914-dd74-708d-afee-1c0ff8f9b4eb",
        "storage_key": "property/6737460151191766/019ea914-dd74-708d-afee-1c0ff8f9b4eb.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.bangbackpinball.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9202787179152769078&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bang-back-pinball-lounge",
      "poi_latitude": "33.9994509",
      "poi_longitude": "-81.01734069999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 803-834-4462",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bb-70de-82c1-f99e154c6890.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bb-70de-82c1-f99e154c6890",
        "storage_key": "property/6737460151191766/019e1e2c-f6bb-70de-82c1-f99e154c6890.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJS_WM767-IgRNoDrVC7etn8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_658ffe55-cbf1-444d-a757-e8c3357afe62",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Segra Park",
      "poi_type": "Entertainment",
      "poi_address": "1640 Freed Street, Columbia, SC 29201, USA",
      "poi_short_description": "Minor-league ballpark that's also an event venue hosting concerts and other gatherings.",
      "poi_long_description": "People say this ballpark offers a great atmosphere for baseball games and other community events, with a wide variety of food and drink options. Visitors highlight the reasonable ticket and concession prices, along with convenient parking and spotless restrooms. They also mention the friendly and helpful staff, making it a great family experience.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019ea914-df76-75ec-a22d-9e997c3233f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea914-df76-75ec-a22d-9e997c3233f2",
        "storage_key": "property/6737460151191766/019ea914-df76-75ec-a22d-9e997c3233f2.webp",
        "width": 1280,
        "height": 846
      },
      "poi_business_url": "https://segrapark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=377377117371658218&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "segra-park",
      "poi_latitude": "34.0184156",
      "poi_longitude": "-81.0312687",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 803-726-4487",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f32c-71ac-9283-2a55c30d5505.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f32c-71ac-9283-2a55c30d5505",
        "storage_key": "property/6737460151191766/019e1e2c-f32c-71ac-9283-2a55c30d5505.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQbC_mNik-IgR6m9MI322PAU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_d1e84b50-d47f-4c6e-a217-25b300940fd9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Craft Axe Throwing",
      "poi_type": "Entertainment",
      "poi_address": "700 Gervais St b2, Columbia, SC 29201, USA",
      "poi_short_description": "Recreation center where visitors can engage in the sport of axe throwing and enjoy craft drinks.",
      "poi_long_description": "People say this recreation center offers axe throwing and a selection of drinks, including beer. They highlight the fun and engaging experience, and the reasonable prices. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019ea914-ddcf-70b8-840e-5fe9afaa7904.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea914-ddcf-70b8-840e-5fe9afaa7904",
        "storage_key": "property/6737460151191766/019ea914-ddcf-70b8-840e-5fe9afaa7904.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://craftaxethrowing.com/us/sc/columbia",
      "poi_directions_map_url": "https://maps.google.com/?cid=18288377151399876632&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "craft-axe-throwing",
      "poi_latitude": "33.9981422",
      "poi_longitude": "-81.04019919999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 803-281-3803",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bc-727d-80fb-44f8b25f3f87",
        "storage_key": "property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvddnFCu7-IgRGFiPix9ezf0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_1c50abdb-c3f7-4be9-87cf-aa858311bda2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Doctors Care",
      "poi_type": "Health and Wellness",
      "poi_address": "1538 Main St. Columbia, SC 29201",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0059b6b5-4838-48f4-a0ef-9ca68b933495",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Graduate by Hilton Columbia, S.C.",
      "poi_type": "Entertainment",
      "poi_address": "1619 Pendleton St, Columbia, SC 29201, USA",
      "poi_short_description": "Hip, vintage-style hotel offering vibrant quarters, a cafe/bar & a 24-hour gym, plus loaner bikes.",
      "poi_long_description": "Guests consistently praise this hotel for its cool and unique aesthetic, comfortable beds, and clean rooms. The friendly and attentive staff, excellent location near the university, and delicious food and good bar drinks are also frequently highlighted.\n\nSome reviews mention the service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019ea914-ddb6-721a-b641-bca19ccc9ffb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea914-ddb6-721a-b641-bca19ccc9ffb",
        "storage_key": "property/6737460151191766/019ea914-ddb6-721a-b641-bca19ccc9ffb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.hilton.com/en/hotels/caegcgu-graduate-columbia-sc/?SEO_id=GMB-AMER-GU-CAEGCGU&y_source=1_MTA1MzY0NDc0NC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=4583041938783185135&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "graduate-by-hilton-columbia-sc",
      "poi_latitude": "34.0011499",
      "poi_longitude": "-81.0249134",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 803-779-7779",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019ea914-ec0e-7062-824d-e822856cd9b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ea914-ec0e-7062-824d-e822856cd9b6",
        "storage_key": "property/6737460151191766/019ea914-ec0e-7062-824d-e822856cd9b6.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJj7YA9U27-IgR76jjf1w8mj8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hotel"
    },
    {
      "id": "custom_4cec2dc8-0220-42aa-8f57-33e9440dcfd9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Jolie Nails and Spa, SC",
      "poi_type": "Health and Wellness",
      "poi_address": "612 Whaley St Suite B, Columbia, SC 29201, USA",
      "poi_short_description": "Contemporary nail salon offering a wide range of colors for gel, acrylic, and dip powder applications.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019ea914-dd88-7669-b419-83f431c42a81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea914-dd88-7669-b419-83f431c42a81",
        "storage_key": "property/6737460151191766/019ea914-dd88-7669-b419-83f431c42a81.webp",
        "width": 1081,
        "height": 608
      },
      "poi_business_url": "http://jolienailsandspa.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6194545683491891050&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jolie-nails-and-spa-sc",
      "poi_latitude": "33.9844837",
      "poi_longitude": "-81.03697129999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 803-661-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bc-727d-80fb-44f8b25f3f87",
        "storage_key": "property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_SgbtrO7-IgRaqd2oXpy91U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_fb2acca3-ebe6-4f87-bd60-1b741d39a46f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Piecewise Coffee Co. - Cayce",
      "poi_type": "Restaurants",
      "poi_address": "2001 State St, Cayce, SC 29033, USA",
      "poi_short_description": "Coffee shop offering breakfast, espresso, and pastries in a laid-back atmosphere.",
      "poi_long_description": "People say this coffee shop serves up delicious cold brew, flavored foam, and cinnamon roll biscuits, and they praise the friendly baristas and homey atmosphere. They also highlight the convenient parking and great location.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019ea914-e202-73c0-9fe0-a2d4a6779379.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea914-e202-73c0-9fe0-a2d4a6779379",
        "storage_key": "property/6737460151191766/019ea914-e202-73c0-9fe0-a2d4a6779379.webp",
        "width": 1280,
        "height": 867
      },
      "poi_business_url": "http://www.piecewisecoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6608036590051558559&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "piecewise-coffee-co---cayce",
      "poi_latitude": "33.97582320000001",
      "poi_longitude": "-81.05269609999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 803-764-1044",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2e-85b8-76c0-aaa6-14fdaf4b8b38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2e-85b8-76c0-aaa6-14fdaf4b8b38",
        "storage_key": "property/6737460151191766/019e1e2e-85b8-76c0-aaa6-14fdaf4b8b38.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJpdFUdHW7-IgRn4TOjER2tFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_9304c449-024b-4027-9830-0aaf7705494b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "940 Harden St, Columbia, SC 29205, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019ea914-e358-703d-9f1f-3d70feb31eff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ea914-e358-703d-9f1f-3d70feb31eff",
        "storage_key": "property/6737460151191766/019ea914-e358-703d-9f1f-3d70feb31eff.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/columbia-south-carolina-1525?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=8969605954012901106&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "34.0031306",
      "poi_longitude": "-81.0174701",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 803-324-6655",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e2c-f6bc-727d-80fb-44f8b25f3f87",
        "storage_key": "property/6737460151191766/019e1e2c-f6bc-727d-80fb-44f8b25f3f87.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV75z9uWl-IgR8u4qmBdxenw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8e9f683e-4015-4f9d-b3c5-1eb747df6f66",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "poi_name": "Columbia Craft Brewery",
      "poi_type": "Restaurants",
      "poi_address": "520 Greene St. Columbia, SC 29201",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_99000a3d-8820-4ec6-9076-0ee5c4a2d58f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_fea0c397-ea67-4ce9-be84-c1fd832157a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_40b78f80-30f8-4afc-a671-caf0a8132eb0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_c4034843-8949-4a2f-9521-cc52942c6c33",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_7ad476e5-7b00-4358-b273-1c5b496ab26f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_42d2aa31-91d9-4748-91f2-e2d7dd3cbc73",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_604820e5-d572-498d-abe4-2d649074f6ba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "day": "SUN",
      "open_time": "12:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_7545daea-ced9-459e-9c20-48f4d9ee1ec7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "rating": "5.0",
      "name": "Jeremy Fagan",
      "text": "I had my in-person tour today with Kara! She had all my questions answered perfectly. I have no complaints.",
      "date": "2026-03-25",
      "title": ""
    },
    {
      "id": "custom_bdd85727-1f93-4c47-866e-73aa9965f157",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "rating": "5.0",
      "name": "CMS Roofing",
      "text": "We have had the opportunity to work with Tyreke, and I can honestly say he is excellent to work with. He is extremely responsive, communicates clearly, and truly cares about the residents and the condition of the property.",
      "date": "2026-03-04",
      "title": ""
    },
    {
      "id": "custom_fbe28717-9d1c-485f-9a76-c27bf2930884",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "rating": "5.0",
      "name": "IZZY X 3.0",
      "text": "I’ve had a great experience so far at River Edge Apartments in Columbia. The complex is in a really convenient location and the property is well kept. The atmosphere feels calm and comfortable, and the whole move-in process was smooth from start to finish.\n\nI especially want to shout out (Brian Myers ) for being so helpful and making everything easy. He answered all of my questions quickly and clearly, and made sure I understood every step. It honestly made the whole experience stress-free.",
      "date": "2026-03-04",
      "title": ""
    },
    {
      "id": "custom_0d48b3d7-4cf7-4110-9e22-3009a72b860f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "rating": "5",
      "name": "Alain Cassagnol",
      "text": "One of the place in South Carolina for living and I applied today with Kason",
      "date": "2026-04-24",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_00148b6e-c4e4-4628-9a48-c3614469fa7d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191766/019e66bb-55fc-7094-a39d-59892aa9dbea.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e66bb-55fc-7094-a39d-59892aa9dbea",
        "storage_key": "property/6737460151191766/019e66bb-55fc-7094-a39d-59892aa9dbea.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Entrance",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=6731298e6ec17f29e286643e"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01993fbe-6ce5-758d-ab22-7ec643f4a337",
      "lead_source": "LANDING_PAGE",
      "name": "rreaf-rivers-edge-at-carolina-stadium-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766"
    },
    {
      "lead_collector_id": "019a185d-6c2d-748e-929e-7e73e02cee0b",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-rivers-edge-at-carolina-stadium-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766"
    },
    {
      "lead_collector_id": "019dfe58-62a9-75b8-a846-ba27a9341ba5",
      "lead_source": "FACEBOOK_ADS",
      "name": "Facebook Ads",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "generator",
      "page_item_url": "apartments-with-in-unit-washer-and-dryer-columbia-sc",
      "search_query": "apartments with in-unit washer and dryer Columbia SC",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Washer and Dryer",
      "h2_subtitle": "Discover Columbia SC apartments featuring in-unit washers and dryers. Enjoy convenient living with appliances right in your unit at Rivers Edge.",
      "page_copy": "Welcome to Rivers Edge at Carolina Stadium, where having an in-unit washer and dryer enhances your lifestyle in Columbia, SC. Imagine the ease and convenience of handling laundry without leaving the comfort of your spacious apartment. Choose from one, two, or three-bedroom options, all thoughtfully designed with modern touches such as stainless steel appliances, including those essential laundry appliances, air conditioning, and serene private patios. \n\nLocated in vibrant Richland County near Greek Village, Rivers Edge is more than just a place to live; it’s a community designed for you. Step into your new home and enjoy plentiful amenities including scenic walking/biking trails perfect for leisure and staying active. Explore the perfect blend of comfort and convenience with our in-unit laundry facilities and make Rivers Edge your ideal residence today. Schedule a tour and see firsthand why our residents love the convenience of having an in-unit washer and dryer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Columbia SC Apartments with In-Unit Laundry",
      "seo_description": "Discover Columbia SC apartments with in-unit washer and dryer at Rivers Edge. Enjoy modern living with convenient amenities. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-greek-village-columbia",
      "search_query": "air-conditioned apartments Greek Village Columbia",
      "category": "Amenity",
      "h1_title": "Air-Conditioned Apartments Near Greek Village",
      "h2_subtitle": "Stay comfortable year-round in our air-conditioned apartments. Discover Rivers Edge near Greek Village in Columbia for modern living.",
      "page_copy": "Experience ideal living at Rivers Edge at Carolina Stadium with our air-conditioned apartments located near Greek Village, Columbia. Our community offers one, two, and three-bedroom apartments equipped with air conditioning, ensuring your home remains a haven of comfort regardless of the season. Embrace a blend of modern conveniences with amenities like stainless steel appliances, a private patio, and plentiful storage space with specifically designed pantries.\n\nNestled in the heart of Richland County, Rivers Edge provides residents not just with a cool retreat, but also a vibrant community lifestyle comprising walking and biking trails perfect for outdoor enthusiasts. Enjoy the convenience of our charming, air-conditioned spaces alongside beautifully maintained grounds in a location that puts you at the center of everything. Schedule your visit today and experience the refreshing comfort of our air-conditioned units at Rivers Edge.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air-Conditioned Apartments in Greek Village",
      "seo_description": "Enjoy air-conditioned apartments near Greek Village, Columbia at Rivers Edge. Modern, comfortable living awaits. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "generator",
      "page_item_url": "apartments-with-dishwasher-richland-county",
      "search_query": "apartments with dishwasher Richland County",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher in Richland County",
      "h2_subtitle": "Explore Richland County apartments featuring dishwashers. Experience modern living at Rivers Edge with convenient amenities.",
      "page_copy": "Welcome to Rivers Edge at Carolina Stadium, offering a modern lifestyle in Richland County with the convenience of apartments equipped with dishwashers. Whether you choose a cozy one-bedroom layout or larger two and three-bedroom options, each apartment is designed with contemporary comfort, including stainless steel appliances, air conditioning, and private patios perfect for relaxation.\n\nLocated in Columbia near the vibrant Greek Village, Rivers Edge is not just a home but a community where convenience meets style. Our residents enjoy upscale amenities like abundant walking and biking trails, making it easy to embrace both leisure and activity right at your doorstep. With a dishwasher in each unit, daily chores become a breeze, giving you more time to enjoy the things that matter. Discover the ease of living at Rivers Edge and schedule a tour of our apartments with dishwashers today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Richland County Apartments with Dishwasher",
      "seo_description": "Find apartments with dishwashers in Richland County at Rivers Edge. Enjoy modern living with convenient amenities. Tour our community today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "generator",
      "page_item_url": "patio-apartments-near-carolina-stadium",
      "search_query": "patio apartments near Carolina Stadium",
      "category": "Amenity",
      "h1_title": "Patio Apartments Near Carolina Stadium",
      "h2_subtitle": "Enjoy outdoor living with our patio apartments near Carolina Stadium. Discover comfort and style at Rivers Edge.",
      "page_copy": "Welcome home to Rivers Edge at Carolina Stadium, where patio apartments offer a perfect blend of indoor and outdoor living. Situated near Carolina Stadium in the bustling city of Columbia, SC, these apartments provide a private outdoor retreat where you can unwind and soak up the scenic surroundings. Choose from spacious one, two, or three-bedroom layouts, each featuring premium amenities like stainless steel appliances and efficient air conditioning.\n\nNestled in Richland County and close to Greek Village, Rivers Edge offers more than just a place to live. With easy access to walking and biking trails, residents can enjoy an active outdoor lifestyle without leaving the community. A private patio is the ideal spot for morning coffee or evening relaxation, allowing you to embrace all the comforts of home in a vibrant, community-focused environment. Explore these patio-equipped apartments at Rivers Edge near Carolina Stadium and schedule your visit today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Patio Apartments Near Carolina Stadium",
      "seo_description": "Discover patio apartments near Carolina Stadium at Rivers Edge. Enjoy outdoor living and modern amenities. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "generator",
      "page_item_url": "modern-stainless-steel-appliances-columbia-sc",
      "search_query": "modern stainless steel appliances Columbia SC",
      "category": "Amenity",
      "h1_title": "Modern Apartments in Columbia SC",
      "h2_subtitle": "Explore Columbia SC apartments with modern stainless steel appliances at Rivers Edge. Experience quality living today.",
      "page_copy": "Discover the perfect blend of style and functionality at Rivers Edge at Carolina Stadium, where apartments are equipped with modern stainless steel appliances in Columbia, SC. Our one, two, and three-bedroom homes offer more than just a place to live—they provide a lifestyle infused with modern convenience and sleek design. Stainless steel appliances not only enhance the aesthetic of your kitchen but also bring durability and ease to your daily routines.\n\nSituated near Greek Village and close to Carolina Stadium, Rivers Edge provides a vibrant living experience in Richland County. Enjoy additional amenities like private patios, walking and biking trails, and essential conveniences such as air conditioning and dishwashers. Each apartment is a testament to modern living, designed to fit both your style and needs. Explore Rivers Edge and find your new home with modern stainless steel appliances today.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Stainless Steel Appliances in Columbia SC",
      "seo_description": "Find apartments with modern stainless steel appliances in Columbia SC at Rivers Edge. Enjoy quality living with top-notch amenities. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-columbia-sc",
      "search_query": "two bedroom apartments columbia sc",
      "category": "Floorplan",
      "h1_title": "Two-Bedroom Apartments in Columbia SC",
      "h2_subtitle": "Discover the ideal two-bedroom apartments in Columbia, SC at Rivers Edge. Experience spacious living with modern amenities.",
      "page_copy": "Welcome to Rivers Edge at Carolina Stadium, where our two-bedroom apartments in Columbia, SC offer the perfect blend of comfort and style. Nestled in the heart of Richland County, these spacious units are designed with modern living in mind, featuring elegant touches and practical amenities like stainless steel appliances and air conditioning. With ample space and thoughtful layouts, our two-bedroom apartments accommodate both individuals and families seeking a cozy, yet efficient living environment.\n\nLocated near the vibrant Greek Village, Rivers Edge provides easy access to local attractions and community conveniences. Enjoy relaxation and recreation with our private patios and extensive walking and biking trails surrounding the area. Experience the charm and functionality of a two-bedroom apartment at Rivers Edge, where quality living meets modern design. Schedule a visit today and see why our Columbia address is the ideal place to call home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two-Bedroom Apartments in Columbia SC",
      "seo_description": "Explore spacious two-bedroom apartments in Columbia SC at Rivers Edge. Modern amenities and convenient location. Schedule your tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-greek-village",
      "search_query": "three bedroom apartments greek village",
      "category": "Floorplan",
      "h1_title": "Three-Bedroom Apartments near Greek Village",
      "h2_subtitle": "Discover spacious three-bedroom apartments near Greek Village. Enjoy the comfort of home at Rivers Edge.",
      "page_copy": "Experience the spacious comfort of three-bedroom apartments at Rivers Edge at Carolina Stadium, located near Greek Village in Columbia, SC. Designed with families and roommates in mind, these apartments offer ample living space, equipped with modern amenities like stainless steel appliances and private patios. Ideally situated, our community provides the perfect escape with all the conveniences of city living just steps away.\n\nAt Rivers Edge, residents enjoy not only spacious interiors but also access to a range of amenities, including walking and biking trails perfect for outdoor enthusiasts. Nestled in Richland County and close to the vibrant social scenes of Greek Village, these three-bedroom homes offer the perfect combination of location and lifestyle. Schedule a tour today and explore how living near Greek Village enhances the comfort and convenience of home life.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three-Bedroom Apartments near Greek Village",
      "seo_description": "Find spacious three-bedroom apartments near Greek Village at Rivers Edge. Enjoy modern amenities and a prime location. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191766",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-richland-county",
      "search_query": "one bedroom apartments richland county",
      "category": "Floorplan",
      "h1_title": "One-Bedroom Apartments in Richland County",
      "h2_subtitle": "Explore stylish one-bedroom apartments in Richland County at Rivers Edge. Enjoy comfort and convenience in Columbia, SC.",
      "page_copy": "Discover the perfect one-bedroom apartments at Rivers Edge at Carolina Stadium in Richland County. These contemporary homes offer a blend of style and function, complete with modern amenities such as stainless steel appliances and private patios. Whether you're a student, a professional, or simply seeking a cozy and convenient living space, our one-bedroom apartments in Columbia, SC are designed to meet your needs.\n\nLocated near the lively Greek Village, Rivers Edge places you at the heart of a vibrant community with access to walking and biking trails. Enjoy the peaceful surroundings while being just steps away from the excitement of Columbia life. Visit Rivers Edge to find a thoughtfully crafted one-bedroom apartment that offers both comfort and proximity to all the essential Richland County attractions. Schedule a tour today!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One-Bedroom Apartments in Richland County",
      "seo_description": "Explore one-bedroom apartments in Richland County at Rivers Edge. Enjoy modern style and convenience in Columbia, SC. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3357"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483376"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5106325"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.riversedgecs.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.riversedgecs.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.riversedgecs.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.riversedgecs.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NQQRX3TF"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.riversedgecs.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.riversedgecs.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.riversedgecs.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.riversedgecs.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.riversedgecs.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.riversedgecs.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_hg_link",
      "type": "STRING",
      "value": "https://www.riversedgecs.com?utm_knock=hg"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_sh_link",
      "type": "STRING",
      "value": "https://www.riversedgecs.com?utm_knock=sh"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "803-471-5198"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.riversedgecs.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.riversedgecs.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "803-887-2942"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_hg_title",
      "type": "STRING",
      "value": "Housing Guide"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.riversedgecs.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.riversedgecs.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_oce_link",
      "type": "STRING",
      "value": "https://www.riversedgecs.com?utm_knock=oce"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.riversedgecs.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.riversedgecs.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "803-258-6739"
    },
    {
      "ID": "custom_knock_sh_title",
      "type": "STRING",
      "value": "Student Housing ILS"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "803-784-8789"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "803-886-0453"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.riversedgecs.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "803-471-4946"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "803-471-4530"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "803-805-7043"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "803-471-4084"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "803-866-7647"
    },
    {
      "ID": "custom_knock_hg_number",
      "type": "STRING",
      "value": "803-871-9354"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_oce_title",
      "type": "STRING",
      "value": "On Campus Event"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.riversedgecs.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_knock_sh_number",
      "type": "STRING",
      "value": "803-676-7895"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "803-902-3139"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.riversedgecs.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "803-258-6749"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.riversedgecs.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "803-590-6993"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "803-653-8235"
    },
    {
      "ID": "custom_knock_oce_number",
      "type": "STRING",
      "value": "803-866-3833"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.riversedgecs.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "803-866-6321"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "803-805-8141"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "803-884-9315"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.riversedgecs.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.riversedgecs.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "803-373-7432"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321118531"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "803-471-5119"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "803-902-2170"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.riversedgecs.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "ee8c11e211ee1379"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.riversedgecs.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "803-877-6701"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.riversedgecs.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "803-258-6979"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "803-471-4091"
    },
    {
      "ID": "custom_knock_outbound_link",
      "type": "STRING",
      "value": "https://www.riversedgecs.com?utm_knock=outbound"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.riversedgecs.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "803-919-1031"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "803-592-3348"
    },
    {
      "ID": "custom_knock_outbound_title",
      "type": "STRING",
      "value": "Outbound"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "803-770-5933"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_outbound_number",
      "type": "STRING",
      "value": "803-258-6759"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "803-471-4979"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.riversedgecs.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151191766/019e8496-d9b4-729b-affa-c59f2e301202.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "803-702-8708"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "803-866-7647"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3357",
  "custom_repli_id": "5028483376",
  "custom_realpage_id": "5106325",
  "custom_knock_a_link": "https://www.riversedgecs.com?utm_knock=a",
  "custom_knock_g_link": "https://www.riversedgecs.com?utm_knock=g",
  "custom_knock_r_link": "https://www.riversedgecs.com?utm_knock=r",
  "custom_knock_w_link": "https://www.riversedgecs.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-NQQRX3TF",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.riversedgecs.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.riversedgecs.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.riversedgecs.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.riversedgecs.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.riversedgecs.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.riversedgecs.com?utm_knock=gp",
  "custom_knock_hg_link": "https://www.riversedgecs.com?utm_knock=hg",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_sh_link": "https://www.riversedgecs.com?utm_knock=sh",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "803-471-5198",
  "custom_knock_ads_link": "https://www.riversedgecs.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.riversedgecs.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "803-887-2942",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_hg_title": "Housing Guide",
  "custom_knock_lcs_link": "https://www.riversedgecs.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.riversedgecs.com?utm_knock=lgp",
  "custom_knock_oce_link": "https://www.riversedgecs.com?utm_knock=oce",
  "custom_knock_ppn_link": "https://www.riversedgecs.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.riversedgecs.com?utm_knock=psa",
  "custom_knock_r_number": "803-258-6739",
  "custom_knock_sh_title": "Student Housing ILS",
  "custom_knock_w_number": "803-784-8789",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "803-886-0453",
  "custom_knock_amap_link": "https://www.riversedgecs.com?utm_knock=amap",
  "custom_knock_ar_number": "803-471-4946",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "803-471-4530",
  "custom_knock_fb_number": "803-805-7043",
  "custom_knock_fl_number": "803-471-4084",
  "custom_knock_gp_number": "803-866-7647",
  "custom_knock_hg_number": "803-871-9354",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_oce_title": "On Campus Event",
  "custom_knock_osoc_link": "https://www.riversedgecs.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_knock_sh_number": "803-676-7895",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "803-902-3139",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.riversedgecs.com?utm_knock=bcard",
  "custom_knock_bnr_number": "803-258-6749",
  "custom_knock_cfres_link": "https://www.riversedgecs.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "803-590-6993",
  "custom_knock_lgp_number": "803-653-8235",
  "custom_knock_oce_number": "803-866-3833",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.riversedgecs.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "803-866-6321",
  "custom_knock_psa_number": "803-805-8141",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "803-884-9315",
  "custom_knock_bandit_link": "https://www.riversedgecs.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.riversedgecs.com?utm_knock=flyers",
  "custom_knock_osoc_number": "803-373-7432",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321118531",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "803-471-5119",
  "custom_knock_cfres_number": "803-902-2170",
  "custom_knock_chatgpt_link": "https://www.riversedgecs.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "ee8c11e211ee1379",
  "custom_knock_dirmail_link": "https://www.riversedgecs.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "803-877-6701",
  "custom_knock_propbro_link": "https://www.riversedgecs.com?utm_knock=propbro",
  "custom_knock_bandit_number": "803-258-6979",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "803-471-4091",
  "custom_knock_outbound_link": "https://www.riversedgecs.com?utm_knock=outbound",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.riversedgecs.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "803-919-1031",
  "custom_knock_dirmail_number": "803-592-3348",
  "custom_knock_outbound_title": "Outbound",
  "custom_knock_propbro_number": "803-770-5933",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_outbound_number": "803-258-6759",
  "custom_knock_revcards_number": "803-471-4979",
  "custom_knock_maintenance_link": "https://www.riversedgecs.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151191766/019e8496-d9b4-729b-affa-c59f2e301202.mp4",
  "custom_knock_maintenance_number": "803-702-8708",
  "custom_ppc_tracking_phone_number": "803-866-7647"
};

export const generatedAt = '2026-10-07T17:15:49.331Z';
